//FlexiGrid - See BoilerplateFlexiGrid for usage.

//    Motivation 1: Reduce refactoring all grids on every grid feature update. Fast foward feature implementations and bugfixes. 
//                  The Grid, data functions, downloads, search inputs, and behavior should be componentized: reusable for other views.
//    Motivation 2: Do away with scrolling through endless boilerplate, componentized elements can simply be configured instead of endlessly declared and adjusted.

//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';
import FlexiRow from './FlexiRow';


import FlexiGridAutoComplete from "./FlexiGridAutoComplete";
import FlexiGridBulkEditAutoComplete from "./FlexiGridBulkEditAutoComplete";



//Revise all the rest of this later
//TO DO, UPDATE REACT-ROUTER SO WE CAN USE USENAVIGATE
import { useLocation, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import PropTypes from 'prop-types';
//import cloneDeep from 'lodash/cloneDeep';

//Redux Features
import { useSelector, useDispatch } from 'react-redux';

//StatusBar
import SaveIcon from '@mui/icons-material/Save';
import PendingIcon from '@mui/icons-material/Pending';
import { StatusBar } from './features/statusbar/StatusBar';
import {
	newStatus,
	incrementPass,
	incrementFail,
	setStatusTimeout
} from './features/statusbar/statusbarSlice';

//Main Menu
import {
	setCurrentMenuSection,
	setCurrentMenuItem
} from '../../../features/mainmenu/mainmenuSlice';

//New Error Message
import { NewErrorMessage } from '../../../features/error/NewErrorMessage';
import {
	newErrorMessage,
	setErrorTimeout
} from '../../../features/error/errormessageSlice';


//Contexts
//Error Context - warning, danger, ok, neutral
import ErrorMessage from "../../common/ErrorMessage";
import { ErrorContext } from '../../common/ErrorContext';

//CSS Styles
import flexstyles from '../../../css/FlexCss';
import useClasses from '../../../ui/useClasses';
import { useMediaQuery } from "@mui/material";

//Datetime formatting
import Moment from 'react-moment';
import 'moment-timezone';
import dayjs from 'dayjs'; //Used with new datetimepickers
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //New adapter for mui x 7 datetime
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

//Common Utilities
import FlexiSearchInput from "./FlexiSearchInput"; //Don't forget localization adapter and switch to DayJS!
import RestrictInputNumber from "../../common/RestrictInputNumber";
import DBAutoComplete from '../../common/DBAutoComplete';

//MaterialUI
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
//import Grid from '@mui/material/GridLegacy';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

//Tables
//import TablePagination from '@mui/material/TablePagination';
import FlexiGridPagination from './FlexiGridPagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import Checkbox from '@mui/material/Checkbox';

//Icons
import Chip from '@mui/material/Chip';
import PreviewIcon from '@mui/icons-material/Preview';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import AddIcon from '@mui/icons-material/Add';
import GridOnIcon from '@mui/icons-material/GridOn';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DownloadIcon from '@mui/icons-material/Download';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

//Datetime Pickers
//Try new moment adapter:
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

//Export
import ExportCSV from '../../common/ExportCSV';

//Utilities - TO DO: Pack more utilties into this file
import { isValueEqual, isRowDirty } from './FlexiGridUtils';


/* ##########################  Configuration  ########################## */

//DB
//Old: var dbendpoint = process.env.REACT_APP_DB_HOSTNAME;
var dbendpoint = process.env.REACT_APP_DB_API4;
var hostbase = process.env.REACT_APP_BASE;

//Default Axios Post Options
const defaultpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 11800,
};

//Long Axios Post Options
const longpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 120000,
};

//Helper Functions
//Have not used sleep just yet - is currently on auto-complete sample
function sleep(delay = 0) {
	return new Promise((resolve) => {
		setTimeout(resolve, delay);
	});
}

//Remove - Useful for completely removing object properties by key. May be used for exports.
function removeProp(obj, key) {
	for (var k in obj) {
		if (k === key) {
			delete obj[key];
			return true;
		} else if (typeof obj[k] === "object") {
			if (removeProp(obj[k], key)) return true;
		}
	}
	return false;
}

//Find Duplicate Example:
//This will short-circuit once some() finds a truthy value.
var values = [
	{ name: 'someName1' },
	{ name: 'someName2' },
	{ name: 'someName4' },
	{ name: 'someName1' }
];

var valueArr = values.map(function (item) { return item.name });
var isDuplicate = valueArr.some(function (item, idx) {
	return valueArr.indexOf(item) !== idx
});
//console.log(isDuplicate);

//Simple Find Duplicates (simple array of values).
//Often used in list text inputs (skus, itemids, serials)
const GetDupeArray = (inputarray) => {
	var results = inputarray.reduce(function (acc, el, i, arr) {
		if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
	}, []);
	return results;
}
//Example:
const input = [1, 1, 2, 3, 3];
const dupearray = GetDupeArray(input);
//console.log("Duplicates: "+dupearray); // = 1,3 (actual array == [1, 3])

//Find and return all unique values:
const GetUniqueArray = (inputarray) => {
	return inputarray.filter((x, i, a) => a.indexOf(x) === i);
}

//Rounding to a precision for validation
function preciseRound(num, precision) {
	const factor = 10 ** precision;
	return Math.round(num * factor) / factor;
}

// //Used for Exports:
// function getValue(obj, path) {
// 	return path.split('.').reduce((acc, part) => acc && acc[part], obj);
//   }


const FlexiGrid = ({ configuration, classes, perms }) => {
	document.title = configuration.title;
	const location = useLocation();
	const history = useHistory();
	const dispatch = useDispatch();

	/* CSS and Media Queries */
	//const classes = useClasses(flexstyles);
	//const isPrintView = useMediaQuery("print");

	//Refs
	const rowRefs = useRef([]);
	const fileInputRef = useRef(null);

	/* ##########################  Top Button Refs and Functions  ########################## */
	//Buttons must exist in order to disable or enable them. Hide buttons with hidden class and ternary.
	const btnSave = useRef();
	const btnPendingSave = useRef();
	const btnAddRow = useRef();
	const btnAddItem = useRef();
	const btnViewOptions = useRef();
	const btnShowExportMenu = useRef();
	const btnDeleteSelected = useRef();
	const btnExpandAll = useRef();
	const btnResetSearches = useRef();
	const btnEditItems = useRef();
	const btnExport = useRef();
	const btnUtilityDrawer = useRef();
	const btnItemList = useRef();
	const btnPrintLabels = useRef();
	const btnEditMode = useRef();

	//Disable Buttons
	const DisableButtons = () => {
		btnSave.current.setAttribute("disabled", true);
		btnPendingSave.current.setAttribute("disabled", true);
		btnAddRow.current.setAttribute("disabled", true);
		btnAddItem.current.setAttribute("disabled", true);
		btnDeleteSelected.current.setAttribute("disabled", true);
		btnExpandAll.current.setAttribute("disabled", true);
		btnResetSearches.current.setAttribute("disabled", true);
		btnEditItems.current.setAttribute("disabled", true);
		btnExport.current.setAttribute("disabled", true);
		btnUtilityDrawer.current.setAttribute("disabled", true);
		btnItemList.current.setAttribute("disabled", true);
		btnPrintLabels.current.setAttribute("disabled", true);
		btnEditMode.current.setAttribute("disabled", true);
	}

	//Enable Buttons
	const EnableButtons = () => {
		btnSave.current.removeAttribute("disabled");
		btnPendingSave.current.removeAttribute("disabled");
		btnAddRow.current.removeAttribute("disabled");
		btnAddItem.current.removeAttribute("disabled");
		btnDeleteSelected.current.removeAttribute("disabled");
		btnExpandAll.current.removeAttribute("disabled");
		btnResetSearches.current.removeAttribute("disabled");
		btnEditItems.current.removeAttribute("disabled");
		btnExport.current.removeAttribute("disabled");
		btnUtilityDrawer.current.removeAttribute("disabled");
		btnItemList.current.removeAttribute("disabled");
		btnPrintLabels.current.removeAttribute("disabled");
		btnEditMode.current.removeAttribute("disabled");
	}

	//Reusable test to be used with useState bool variables
	//Invalid for none selected or pending changes
	//Bulk Edit Selected
	//Export Selected
	//Print Selected
	const RejectIfInvalidSelected = (value, fnCallback) => {
		if (localstate.selectedindexes.length === 0) {
			dispatch(newStatus({
				type: "warning",
				msg: 'No items selected.',
				show: true,
				settimeout: true, //This option allows for a timeout after the final item is pass/failed
				timeout: 10, //Initiated on final item 
				itemtype: 'items', //Labels your save types such as items, products, skus, parts
				finished: 0,
				percent: "0%",
				total: 5,
				pass: 0,
				fail: 0,
				faillist: [], //Can take simple values,
				faillinks: [], //Can take links to things like items or products.
				timeoutid: false,
				errors: [] //Can take strings
			}));
			//dispatch(newStatus({ errmsg: "No items selected.", errshow: true, errtimeout: 5, errtype: 'neutral' }));
			dispatch(setStatusTimeout(5000));
		} else {
			//If all tests pass, use callback
			fnCallback(value);
		}
	}

	//Edit Mode
	const [editmode, setEditMode] = useState(true); //Default: false
	const EditMode = () => {
		setEditMode(!editmode);
		CloseViewOptionsMenu();
	}


	/* ##########################  Menus  ########################## */

	const ToggleColumn = (column) => {
		column.visible = !column.visible;
		UpdateState(localstate);
	}
	const FlexColumnOption = (props) => {
		let column = props.column;
		return (
			<React.Fragment>
				{(column.visible) &&
					<FormControlLabel control={<Checkbox defaultChecked onClick={() => { ToggleColumn(column) }} />} label={column.columnoptionlabel} className={classes.columnselecthover} />
				}
				{(!column.visible) &&
					<FormControlLabel control={<Checkbox onClick={() => { ToggleColumn(column) }} />} label={column.columnoptionlabel} className={classes.columnselecthover} />
				}
			</React.Fragment>
		)
	}

	/* View Options Menu */
	const [showViewOptionsMenu, setShowViewOptionsMenu] = useState(false);
	const ShowViewOptionsMenu = () => {
		//console.log(event);
		setShowViewOptionsMenu(true);
	}
	const CloseViewOptionsMenu = () => {
		setShowViewOptionsMenu(false);
	}

	/* Edit Menu */
	const [showViewEditMenu, setViewEditMenu] = useState(null);
	const ShowViewEditMenu = (event) => {
		setViewEditMenu(event.currentTarget);
	}
	const CloseViewEditMenu = () => {
		setViewEditMenu(null);
	}


	/* Export Menu */
	const [showexportmenu, setExportMenu] = useState(null);
	const ShowExportMenu = (event) => {
		setExportMenu(true);
	}
	const CloseExportMenu = () => {
		setExportMenu(null);
	}


	/* ##########################  Selected Rows  ########################## */
	//Explanation: Since we're using <Checkbox> from materialui in an uncontrolled manner (avoiding state, avoiding rerenders...)
	//we are assuming the only way to show a "checked" value of the checkbox is by a user clicking the actual checkbox.

	//Simply using rowRefs.current[index+"Checkbox"].checked can be set to "true", but the view WILL NOT REFLECT THE CHANGE.
	//So for manual clicks on <Checkbox> we register in localstate - to be used later and maintained by UpdateState(localstate).
	//For SelectAll, we have to run through all items and set isSelected, then rerender.
	//Non-direct interaction with checkbox components will result in difficulty trying to access it through some kind
	//of ref/DOM manipulation. Therefore we pass changes to these components through state changes, mutating localstate.

	const SelectRow = (index) => {
		//console.log("Selected index: " + index);
		if (localstate.selectedindexes.indexOf(index) === -1) {
			localstate.selectedindexes.push(index);
			localstate.griditems[index].isSelected = true;
			//Check for condition that would check Select All Checkbox - Requires Rerender
			if (localstate.griditems.length === localstate.selectedindexes.length) {
				UpdateState(localstate);
			}
		} else {
			var spliceindex = localstate.selectedindexes.indexOf(index);
			localstate.selectedindexes.splice(spliceindex, 1);
			localstate.griditems[index].isSelected = false;
			//Check for condition that would un-check Select All Checkbox (if it's checked because for example, 10 grid items = 9 grid items plus 1.) This would force a rerender to get that thing unchecked for us.
			if (localstate.griditems.length === (localstate.selectedindexes.length + 1)) {
				//alert();
				UpdateState(localstate);
			}
		}

		//Provision to close export if nothing is selected
		if (localstate.selectedindexes.length === 0) {
			setShowExportConfirmation(false);
		}
		//console.log("End of SelectRow()");
		//console.log(localstate.selectedindexes);
		UpdateState(localstate);
	}

	const handleSelectAllClick = (event) => {
		//Material UI Checkbox Component won't rerender unless we force it. Set a changed GridKey so that shallow comparison fails.
		var i = 0;
		if (event.target.checked) {
			localstate.selectedindexes = [];
			for (i = 0; i < localstate.griditems.length; i++) {
				localstate.griditems[i].isSelected = true;
				localstate.defaultvalues[i].isSelected = true;
				localstate.selectedindexes.push(i);
				localstate.griditems[i].GridKey++;
			}
			UpdateState(localstate);
		} else {
			localstate.selectedindexes = [];
			localstate.selectedcount = 0;
			for (i = 0; i < localstate.griditems.length; i++) {
				localstate.griditems[i].isSelected = false;
				localstate.defaultvalues[i].isSelected = false;
				localstate.griditems[i].GridKey++;
			}
			UpdateState(localstate);
		}
		//Provision to close export if nothing is selected
		if (localstate.selectedindexes.length === 0) {
			setShowExportConfirmation(false);
		}
	};



	/* ##########################  Search Options  ########################## */


	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};



	/* ##########################  CONFIGURATION SECTION  ###################################################################################################################################################### */
	/* ######################################################################################################################################################################################################### */

	//Search Configuration:
	const activesearchescount = configuration.maximuminputs;


	/* ##########################  UseState Variables  ######################################################################################################################################################### */
	/* ######################################################################################################################################################################################################### */
	const [state, setState] = useState({
		configuration: configuration,
		viewmode: (configuration.hasOwnProperty('viewmode') ? configuration.viewmode : "grid"),
		dbreload: true, 		//Use in useEffect to check if we should reload the griditems data. Set to false when we're just updating current view items.
		renderkey: uuidv4(), //Attempt to get the grid to rerender
		clearselection: true,//Default clear selection everytime we reload DB. Continuous bulk edits may set this to false between updates.
		griditems: [],		//Empty object
		defaultvalues: [],   //Default values: Useful for initial render and avoiding changing defaults during edits.
		totalitems: 0,
		page: 0, //Assume page 0, or else pagination throws an error.
		order: configuration.order,
		orderby: configuration.orderby,
		selectedcount: 0,
		rowsperpage: configuration.rowsperpage,
		rowsperpageoptions: configuration.rowsperpageoptions,
		selectedindexes: [],
		pendingsaves: false, //Used for parent view - Warnings about unsaved items!
		//expandsearch: false, //Used to control optional add/remove search button that shows within input.
		searchoptions: {
			// SEARCH PAIRS: Works with common get() functions on db endpoints. Works with SearchTools to create queries.
			// Also integrates with React <FlexiSearchInput /> functional component which can also take parameters for AutoComplete.
			//Modes: like, left, right, strict, not, bool, datetimeafter, datetimebefore, select
			//Remember to setup a <FlexiSearchInput /> container for each of these.
			searchpairs: {
				//Be sure to adjust activesearchescount 
				searchpair1: configuration.configuredinputs[0],
				searchpair2: configuration.configuredinputs[1],
				searchpair3: configuration.configuredinputs[2],
				searchpair4: configuration.configuredinputs[3],
				searchpair5: configuration.configuredinputs[4],
				searchpair6: configuration.configuredinputs[5],
				searchpair7: configuration.configuredinputs[6],
				searchpair8: configuration.configuredinputs[7],
			},
			viewdeleted: false,
			nestedrelationships: configuration.nestedrelationships,
			itemlist: "",
			itemlistkey: "",
		}
	});

	//Clone state
	let localstate = Object.assign({}, state);

	function UpdateState(stateobject) {
		setState(stateobject);
	}


	//SETUP ROW REFS AND STYLING BEFORE THE FLEXIROW RENDERS
	//Instead, just keep it all syncronized, no need to wait:
	rowRefs.current = {};
	//var currentcolumns=[];
	state.griditems.forEach((row, idx) => {
		rowRefs.current[idx + "SaveStatus"] = React.createRef();
		state.configuration.columns.forEach((column) => {
			//If the column is editable and editmode, we'll need a ref to control it!
			if ((column.editable || column.hasOwnProperty('requiresref')) && editmode) {
				rowRefs.current[idx + column.field] = React.createRef();
			}
			// //We can now determine if this is a 'currentcolumn', meaning we can more easily calculate the style that will control all of the rows.
			// if (column.visible){
			// 	currentcolumns.push(column);
			// }
		});

		const currentcolumns = localstate.configuration.columns.filter(c => c.visible);

		// Given currentcolumns = configuration.columns.filter(c => c.visible)
		currentcolumns.forEach((column, columnindex) => {
			const prevCol = currentcolumns[columnindex - 1];
			const nextCol = currentcolumns[columnindex + 1];

			let style = null;

			// FIRST COLUMN RULES
			if (columnindex === 0) {
				if (
					column.borders === "all" &&
					nextCol &&
					(nextCol.borders === "noleft" || nextCol.borders === "noleftorright")
				) {
					style = {
						border: "1px solid #BBB",
						borderWidth: "1px 0px 1px 1px",
						textAlign: column.valuetextalign
					};
				} else if (column.borders === "noleft") {
					style = {
						border: "1px solid red",
						textAlign: column.valuetextalign
					};
				} else if (column.borders === "noright") {
					style = {
						border: "1px solid green",
						borderWidth: "1px 0px 1px 1px",
						textAlign: column.valuetextalign
					};
				} else if (column.borders === "noleftorright") {
					style = {
						border: "1px solid #BBB",
						borderWidth: "1px 0px 1px 1px",
						textAlign: column.valuetextalign
					};
				} else {
					style = {
						border: "1px solid #BBB",
						borderWidth: "1px 1px 1px 1px",
						textAlign: column.valuetextalign
					};
				}
			}

			// NON-FIRST COLUMN RULES
			else {
				if (column.borders === "all") {
					if (
						//Check left column
						prevCol &&
						(prevCol.borders === "noright" || prevCol.borders === "noleftorright")
					) {
						//Check right column
						if (
							nextCol &&
							(nextCol.borders === "noleft" || nextCol.borders === "noleftorright")
						) {
							//Both side trimmed of border
							style = {
								border: "1px solid #BBB",
								borderWidth: "1px 0px 1px 0px",
								textAlign: column.valuetextalign,
							};
						} else {
							style = {
								border: "1px solid #BBB",
								borderWidth: "1px 1px 1px 0px",  // no left border only
								textAlign: column.valuetextalign,
							};
						}
					} else {
						//Above confirms we don't need to work from a potential issue with left col. Now check right col (nextCol)
						if (nextCol && (nextCol.borders === "noleft" || nextCol.borders === "noleftorright")) {
							//Trim right only
							style = {
								border: "1px solid #BBB",
								borderWidth: "1px 0px 1px 1px",  // no left border only
								textAlign: column.valuetextalign,
							};
						} else {
							//All is well, render all borders?
							style = {
								border: "1px solid #BBB",
								borderWidth: "1px 1px 1px 1px",  // no left border only
								textAlign: column.valuetextalign,
							};
						}
					}
				}

				if (column.borders === "noleft") {
					if (
						nextCol &&
						(nextCol.borders === "noleft" || nextCol.borders === "noleftorright")
					) {
						style = {
							border: "1px solid #BBB",
							borderWidth: "1px 0px 1px 0px",
							textAlign: column.valuetextalign
						};
					} else {
						style = {
							border: "1px solid #BBB",
							borderWidth: "1px 1px 1px 0px",
							textAlign: column.valuetextalign
						};
					}
				}

				else if (column.borders === "noright") {
					if (
						prevCol &&
						(prevCol.borders === "noright" || prevCol.borders === "noleftorright")
					) {
						style = {
							border: "1px solid #BBB",
							borderWidth: "1px 0px 1px 0px",
							textAlign: column.valuetextalign
						};
					} else {
						style = {
							border: "1px solid #BBB",
							borderWidth: "1px 0px 1px 1px", // fixed typo from "0x"
							textAlign: column.valuetextalign
						};
					}
				}

				else if (column.borders === "noleftorright") {
					if (nextCol) {
						style = {
							border: "1px solid #BBB",
							borderWidth: "1px 0px 1px 0px",
							textAlign: column.valuetextalign
						};
					} else {
						style = {
							border: "1px solid #BBB",
							borderWidth: "1px 1px 1px 0px",
							textAlign: column.valuetextalign
						};
					}
				}
			}

			//Wedge in other changes we'll need for table cells!
			//Autocomplete
			if (column.render === "autocomplete") {
				style.verticalAlign = "bottom";
			}

			//Maincheckbox, don't grow!
			if (column.render === "maincheckbox") {
				style.width = "32";
			}

			//See what control we can dereive from the column configuration
			if (column.columnheadermaxwidth){
				style.maxWidth = column.columnheadermaxwidth;
			}


			// Assign style directly to original configuration
			column.cellstyle = style;
		});
	});





	/* ##########################  Column States - ColStates  ################################################################################################################################################## */
	/* ######################################################################################################################################################################################################### */
	//Used for hiding/showing columns. Can access using bracket notation later on! colstate[headCell.id]
	const [colstate, setColState] = useState({
		Name: true,
		Cost: true,
		Price: true,
		Margin: true,
		PositiveInteger: true,
		SomeBoolean: true,
		SomeSelectable: true,
		NewCheckbox: true,
		Date: true
	});
	const UpdateColState = (colstate) => {
		setColState(colstate);
	}

	const ToggleViewDeleted = () => {
		localstate.searchoptions.viewdeleted = !localstate.searchoptions.viewdeleted;
		localstate.dbreload = true;
		UpdateState(localstate);
	}

	//Each FlexiSearchInput will need a key that is refreshed to force a re-render.
	//Required to drive the control of the SearchInput from the parent.
	const [key1, setKey1] = useState(uuidv4());
	const [key2, setKey2] = useState(uuidv4());
	const [key3, setKey3] = useState(uuidv4());
	const [key4, setKey4] = useState(uuidv4());
	const [key5, setKey5] = useState(uuidv4());
	const [key6, setKey6] = useState(uuidv4());
	const [key7, setKey7] = useState(uuidv4());
	const [key8, setKey8] = useState(uuidv4());


	//Used for <FlexiSearchInput />
	const onChangeSearchType = (searchpair, searchnumber) => {
		//Only rerender table if searchvalue wasn't blank!
		//console.log("onChangeSearchType called for searchnumber " + searchnumber);
		//console.log(searchpair);
		//Possible these searchpairs don't have values somehow...
		//console.log(localstate.searchoptions.searchpairs); //Just searchpair 5 undefined?!
		if (typeof localstate.searchoptions.searchpairs["searchpair" + searchnumber].value === 'object') {
			if (localstate.searchoptions.searchpairs["searchpair" + searchnumber].value.length > 0) {
				ResetPendingSaves();
				localstate.page = 0;
				localstate.dbreload = true;
			}
		}
		//If datetime is initiated, it will have it's initial value in searchpair.value.
		if (typeof localstate.searchoptions.searchpairs["searchpair" + searchnumber].value === 'string') {
			if (localstate.searchoptions.searchpairs["searchpair" + searchnumber].value !== "" || searchpair.value !== "") {
				ResetPendingSaves();
				localstate.page = 0;
				localstate.dbreload = true;
			}
		}
		if (typeof localstate.searchoptions.searchpairs["searchpair" + searchnumber].value === 'number') {
			//Doesn't matter, 0 or 1, we still need to allow this bool to clear
			ResetPendingSaves();
			localstate.page = 0;
			localstate.dbreload = true;
		}
		localstate.searchoptions.searchpairs["searchpair" + searchnumber] = searchpair;
		UpdateState(localstate);
		//Ensures the input is rerendered and will work correctly:
		ResetKeys([searchnumber], false);
	};

	const onChangeSearchValue = debounce(function (searchvalue, searchpair, searchnumber) {
		//Clears out changes because table is about to be reloaded:
		ResetPendingSaves();
		//Possible search validation here such as proper date format or int/float...
		//For AutoComplete, you will likely need to pull some kind of ID or name before setting the searchvalue!		
		localstate.searchoptions.searchpairs["searchpair" + searchnumber] = searchpair;
		localstate.searchoptions.searchpairs["searchpair" + searchnumber].value = searchvalue;
		localstate.page = 0;
		localstate.dbreload = true;
		//Function to compose all searchoptions and refresh page
		//UrlRedirect();
		UpdateState(localstate);
	}, 1200);

	const onChangeSearchValueFast = (searchvalue, searchpair, searchnumber) => {
		//Clears out changes because table is about to be reloaded:
		ResetPendingSaves();
		//Possible search validation here such as proper date format or int/float...
		//For AutoComplete, you will likely need to pull some kind of ID or name before setting the searchvalue!		
		localstate.searchoptions.searchpairs["searchpair" + searchnumber] = searchpair;
		localstate.searchoptions.searchpairs["searchpair" + searchnumber].value = searchvalue;
		localstate.page = 0;
		localstate.dbreload = true;
		//UrlRedirect();
		UpdateState(localstate);
	};

	//This function digests values from children, usually not for DB reload purposes, but for key-up. Avoid adding UpdateState here, this is simply so we can save user input to parent.
	const UpdateParentState = (searchvalue, searchpair, searchnumber) => {
		//We need parent state to have a current copy of our search inputs, or else they don't all work on submission
		localstate.searchoptions.searchpairs["searchpair" + searchnumber] = searchpair;
		localstate.searchoptions.searchpairs["searchpair" + searchnumber].value = searchvalue;
	};

	//AutoComplete Still needs to send an update so that our inputValue can remain between multiple selections:
	const onChangeAutoCompleteInput = (searchpair, searchnumber) => {
		localstate.searchoptions.searchpairs["searchpair" + searchnumber] = searchpair;
		UpdateState(localstate);
	};


	//Test Redirection
	const UrlRedirect = () => {
		//var navigate = useNavigate();
		//Create URL from search options:
		for (var i = 1; i <= activesearchescount; i++) {
			var searchpair = localstate.searchoptions.searchpairs["searchpair" + i];
			if (searchpair.value !== "" && searchpair.value !== null && typeof searchpair.value !== 'undefined' && !(Array.isArray(searchpair.value) && searchpair.value.length === 0)) {
				//Valid value, add to URL
				history.push({
					pathname: location.pathname,
					search: '?' + encodeURIComponent(searchpair.type) + '=' + encodeURIComponent(searchpair.value)
				});


				// //const encodedDatetime = encodeURIComponent('2026-01-28T20:46:06');  // Your encoded value
				// const newPath = location.pathname+'?'+encodeURIComponent(searchpair.type) + '=' + encodeURIComponent(searchpair.value);
				
				// // Client-side navigation (no reload)
				// navigate(newPath);

				//Only add first valid search to URL for now.
				break;
			} else {
				//No valid value, reset URL
				history.push({
					pathname: location.pathname,
					search: ''
				});
			}
		}
	}

	const ResetSearches = () => {
		//Just reload the page
		history.push(location.pathname);


		// //Reset all:
		// //Use orignal configuration.inputdefaults
		// localstate.searchoptions.searchpairs.searchpair1 = configuration.inputdefaults[configuration.resetarray[0]];
		// localstate.searchoptions.searchpairs.searchpair2 = configuration.inputdefaults[configuration.resetarray[1]];
		// localstate.searchoptions.searchpairs.searchpair3 = configuration.inputdefaults[configuration.resetarray[2]];
		// localstate.searchoptions.searchpairs.searchpair4 = configuration.inputdefaults[configuration.resetarray[3]];
		// localstate.searchoptions.searchpairs.searchpair5 = configuration.inputdefaults[configuration.resetarray[4]];
		// localstate.searchoptions.searchpairs.searchpair6 = configuration.inputdefaults[configuration.resetarray[5]];
		// localstate.searchoptions.searchpairs.searchpair7 = configuration.inputdefaults[configuration.resetarray[6]];
		// localstate.searchoptions.searchpairs.searchpair8 = configuration.inputdefaults[configuration.resetarray[7]];

		// //Set Defaults:
		// setItemListSearch('');
		// localstate.dbreload = true;
		// UpdateState(localstate);

		// //Forcefully rerender search inputs!
		// ResetKeys([], true);
	}

	const ResetKeys = (keyarray, resetallbool) => {
		if (resetallbool) {
			setKey1(uuidv4());
			setKey2(uuidv4());
			setKey3(uuidv4());
			setKey4(uuidv4());
			setKey5(uuidv4());
			setKey6(uuidv4());
			setKey7(uuidv4());
			setKey8(uuidv4());
		} else {
			for (var i = 0; i < keyarray.length; i++) {
				if (keyarray[i] === 1) {
					setKey1(uuidv4());
				}
				if (keyarray[i] === 2) {
					setKey2(uuidv4());
				}
				if (keyarray[i] === 3) {
					setKey3(uuidv4());
				}
				if (keyarray[i] === 4) {
					setKey4(uuidv4());
				}
				if (keyarray[i] === 5) {
					setKey5(uuidv4());
				}
				if (keyarray[i] === 6) {
					setKey6(uuidv4());
				}
				if (keyarray[i] === 7) {
					setKey7(uuidv4());
				}
				if (keyarray[i] === 8) {
					setKey8(uuidv4());
				}
			}
		}
	}


	//Expand Search
	const ToggleExpandSearch = () => {
		localstate.configuration.expandsearch = !localstate.configuration.expandsearch;

		if (!localstate.configuration.expandsearch) {
			for (var i = 5; i <= activesearchescount; i++) {
				//Only rerender if one of the searches wasn't blank!
				if (typeof localstate.searchoptions.searchpairs["searchpair" + i].value === 'object') {
					if (localstate.searchoptions.searchpairs["searchpair" + i].value.length > 0) {
						ResetPendingSaves();
						localstate.page = 0;
						localstate.dbreload = true;
					}
				}
				if (typeof localstate.searchoptions.searchpairs["searchpair" + i].value === 'string') {
					//console.log(localstate.searchoptions.searchpairs["searchpair" + i].value);
					if (localstate.searchoptions.searchpairs["searchpair" + i].value !== "") {
						ResetPendingSaves();
						localstate.page = 0;
						localstate.dbreload = true;
					}
				}
			}
			//Proceed to Reset Partial Searches 5-8:
			localstate.searchoptions.searchpairs.searchpair5 = configuration.inputdefaults[configuration.resetarray[0]];
			localstate.searchoptions.searchpairs.searchpair6 = configuration.inputdefaults['Cost >'];
			localstate.searchoptions.searchpairs.searchpair7 = configuration.inputdefaults.NewCheckbox;
			localstate.searchoptions.searchpairs.searchpair8 = configuration.inputdefaults.SomeSelectable;
		}
		CloseViewOptionsMenu();
		UpdateState(localstate);
	}

	//Customize AddRow
	//This is for in-table row additions.
	const AddRow = () => {
		// It is apparent that I need to commit for each row and get an ID. Then we can handle the updates differently.

		axios.post(dbendpoint + "/flexigrid/addrow", defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === 'login') {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				if (res.data.Status === 'Success') {
					localstate.griditems.unshift({
						PendingItem: 1, //Adds the ability for a person with CREATE perm to edit and change this row once.
						ID: res.data.item.ID,
						Name: "New Item",
						Cost: 0.00,
						Price: 0.00,
						Margin: 0.00,
						PositiveInteger: 0,
						SomeBoolean: 0,
						SomeSelectable: "",
						NewCheckbox: false,
						Date: res.data.item.Date, //dayjs(res.data.item.Date),
						unsaved: false,
						ExpandRow: false,
						isSelected: false,
						GridKey: uuidv4()
					});
					//Pushes selected indexes down
					for (var i = 0; i < localstate.selectedindexes.length; i++) {
						localstate.selectedindexes[i] += 1;
					}
					UpdateState(localstate);

				}
				if (res.data.Status === 'Failure') {
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "neutral" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(10));
			}
		});
	}

	//Add Item
	//Method creates a new item in the DB and returns the ID so we can then load it in item view
	const AddItem = () => {
		//Send DB model to flexigrid
		const postdata = {
			dbmodel: localstate.configuration.dbmodel
		}
		axios.post(dbendpoint + "/flexigrid/additem", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === 'login') {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				if (res.data.Status === 'Success') {
					//window.open('/boilerplatekeyvalues/' + res.data.item.ID);
					window.open(localstate.configuration.newitemviewurlprefix+res.data.item[localstate.configuration.itemskey]);
				}
				if (res.data.Status === 'Failure') {
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "neutral" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(10));
			}
		});
	}





	/* ##########################  Configuration: Custom Views & Functions  ########################## */

	const SetCustomView1 = () => {
		//Applies a few as set to true.
		let newcolstate = colstate;
		newcolstate['Name'] = true;
		newcolstate['Cost'] = true;
		newcolstate['Margin'] = true;
		UpdateColState(newcolstate);
		CloseViewOptionsMenu();
	}



	/* ########################## CUSTOM API CALLS, EXAMPLE Post Test  ########################## */
	//Useful for making test API calls.
	// Simply remove customendpoint if you want to call the basic testpost method at the top of BasicTableController.
	const TestPost = (customendpoint) => {
		if (!customendpoint) { customendpoint = "/testpost" }
		//Sample postdata.
		const postdata = {
			specs: {
				BootID: uuidv4()
			}
		};
		axios.post(dbendpoint + customendpoint, postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					//console.log(res);
				}
				if (res.data.Status === "Failure") {
					//Failure error
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "neutral" }));
					dispatch(setErrorTimeout(5));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(5));
			}
		}).catch(err => {
			//Error getting any response
			dispatch(newErrorMessage({ errmsg: "Caught request error.", errshow: true, errtimeout: 5, errtype: "danger" }));
			dispatch(setErrorTimeout(5));
		});
	}

	/* ##########################  END OF CONFIGURATION SECTION  ########################## */
	/* Continue setting up app with the configuration variable set */




	/* ##########################  Loading and Page Changes  ########################## */
	//Attempt to deprecate!
	const handleRequestSort = (event, property) => {
		//This evaluates if we're requesting the same property and if it's asc.
		const isAsc = localstate.orderby === property && localstate.order === "asc";
		//We need to evaluate if we should start back at page 1:
		if (localstate.orderby !== property) {
			localstate.page = 0;
		}
		localstate.order = (isAsc ? "desc" : "asc");
		localstate.orderby = property;
		localstate.dbreload = true;
		UpdateState(localstate);
	};

	const sortByColumn = (column) => {
		if (localstate.orderby === column.field) {
			//We are already ordered by the current option. Now we need to toggle order asc or desc
			if (localstate.order === "asc") {
				localstate.order = "desc";
			} else if (localstate.order === "desc") {
				localstate.order = "asc";
			}
			localstate.dbreload = true;
			UpdateState(localstate);
		} else {
			//New Property! Use defaultsortorder
			localstate.orderby = column.field;
			localstate.order = column.defaultsortorder;
			localstate.dbreload = true;
			UpdateState(localstate);
		}
	}

	const handleChangePage = (event, newPage) => {
		localstate.dbreload = true;
		localstate.page = newPage;
		UpdateState(localstate);
		//
	};

	const handleChangeRowsPerPage = (event) => {
		localstate.dbreload = true;
		localstate.rowsperpage = parseInt(event.target.value, 10);
		localstate.page = 0;
		UpdateState(localstate);
	};

	//Error Context
	const errors = useContext(ErrorContext);

	//Load Items
	function LoadItems() {
		//Try: Clear any error messages on load of any set of items:
		dispatch(setErrorTimeout(0));
		if (localstate.clearselection) {
			localstate.selectedindexes = [];
			localstate.selectedcount = 0;
		} else {
			//Reset to clear selections on subsequent requests
			localstate.clearselection = true;
		}

		//Prepare Searchpairs - You may need to follow this pattern in PrepareExport()
		//Need to DEEP clone:
		//console.log(localstate);
		var clonedsearchpairs = JSON.parse(JSON.stringify(localstate.searchoptions.searchpairs));

		//console.log(clonedsearchpairs);
		//Create new set which will only have up to activesearchescount searchpairs added.
		var newsearchpairs = {};

		//AUTOCOMPLETE AND SELECT Handler
		//The SearchTools controller will treat any search with multiple=true as an ormode with merged array values. 
		for (var i = 1; i < (activesearchescount + 1); i++) {
			//If there aren't enough values in priorityarray, it won't be able to fill the required searchpairs!
			newsearchpairs["searchpair" + i] = clonedsearchpairs["searchpair" + i];
			//Products Autocomplete
			//console.log("################:   "+i);
			//console.log(clonedsearchpairs["searchpair" + i]);
			if (clonedsearchpairs["searchpair" + i].mode === "autocomplete" && clonedsearchpairs["searchpair" + i].type === "products") {
				newsearchpairs["searchpair" + i].type = "ProductID";
				//Note: You may change the "mode" and possibly rely on SearchTools to handle an array (if detected!)
				//We don't normally change the mode, instead allowing our TableController to handle special auto-completed values, normally relationship based values.
				//To simplify same-layer table values such as "ProductID", we might leverage our already working ormode code to handle an array value!
				//Test a new non-short circuited ProductID search using mode="like" in SkusTable.js
			}
			//.... More Rules
			//Some select mode items may be converted to "like"
		}

		const postdata = {
			searchoptions: {
				limit: localstate.rowsperpage,
				currentsort: localstate.orderby,
				currentsortdir: localstate.order,
				searchpairs: newsearchpairs,
				nestedrelationships: localstate.searchoptions.nestedrelationships,
				viewdeleted: localstate.searchoptions.viewdeleted,
				dbmodel: localstate.configuration.dbmodel,
				itemskey: localstate.configuration.itemskey,
				//DB table supports:
				//Try to give all new tables these supports:
				softdeletesupport:localstate.configuration.softdeletesupport,
				creationusersupport:localstate.configuration.creationusersupport,
				updateusersupport:localstate.configuration.updateusersupport,
				deleteusersupport:localstate.configuration.deleteusersupport,
				//Datetimes
				datetimes:localstate.configuration.datetimes
			}
		};

		if (itemlistsearch.length > 0) {
			//Serials exist in serial list.
			postdata.searchoptions.itemlist = itemlistsearch;
			postdata.searchoptions.itemlistkey = itemlistkey;
		}

		axios.post(dbendpoint + localstate.configuration.apiendpoint + "getitems?page=" + (localstate.page + 1), postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					//We should now have a non-0 result from the API
					//Add variables for use with table or exports
					var resultdata = res.data.pagedata.data;
					if (localstate.configuration.mutatedata){
						resultdata = localstate.configuration.mutatedata(resultdata); 
					}

					for (var i = 0; i < resultdata.length; i++) {
						//Try: GridKey - Apply GridKey to components: key={row.GridKey}
						//Try: Increment GridKey between rerenders; ie: UpdateState(localstate);
						resultdata[i].GridKey = i;
						resultdata[i].unsaved = false;
						resultdata[i].ExpandRow = false;
						if (localstate.selectedindexes.includes(i)) {
							resultdata[i].isSelected = true;
						} else {
							resultdata[i].isSelected = false;
						}

						//Set Defaults for selectables:
						resultdata[i].SomeSelectableDefault = resultdata[i].SomeSelectable;

						//If some value, you can reset a searchinput by adding an index and sending it to ResetKeys(keyarray)
						//resetarray.push(i);
					}
					localstate.griditems = JSON.parse(JSON.stringify(resultdata));

					//Hold items for default values - Let's plan on using this for $dirty as well!
					localstate.defaultvalues = JSON.parse(JSON.stringify(resultdata));

					localstate.totalitems = res.data.pagedata.total;
					//Data freshly loaded, head off any new requests with this state change. Handle in useEffect?
					//localstate.dbreload = false;
					UpdateState(localstate);

					dispatch(newStatus({
						type: "dataloaded",
						msg: 'Data loaded',
						show: true,
						settimeout: true, //This option allows for a timeout after the final item is pass/failed
						timeout: 5, //Initiated on final item 
						itemtype: 'items', //Labels your save types such as items, products, skus, parts
						finished: 0,
						percent: "0%",
						pass: 0,
						fail: 0,
						faillist: [], //Can take simple values,
						faillinks: [], //Can take links to things like items or products.
						timeoutid: false,
						errors: [] //Can take strings
					}));
					dispatch(setStatusTimeout(500));
					//ResetKeys(resetarray);
				}
				if (res.data.Status === "No Items") {
					//Failure error
					localstate.griditems = [];
					localstate.totalitems = 0;
					UpdateState(localstate);
					//Really no need for an error here.
				}
				if (res.data.Status === "Failure") {
					//Failure error
					localstate.griditems = [];
					localstate.totalitems = 0;
					UpdateState(localstate);
					dispatch(newStatus({
						type: "requesterror",
						msg: 'API request failure.',
						show: true,
						settimeout: true, //This option allows for a timeout after the final item is pass/failed
						timeout: 5, //Initiated on final item 
						itemtype: 'items', //Labels your save types such as items, products, skus, parts
						finished: 0,
						percent: "0%",
						pass: 0,
						fail: 0,
						faillist: [], //Can take simple values,
						faillinks: [], //Can take links to things like items or products.
						timeoutid: false,
						errors: [] //Can take strings
					}));
				}
			} else {
				dispatch(newStatus({
					type: "requesterror",
					msg: 'API request failure, non-200 response.',
					show: true,
					settimeout: true, //This option allows for a timeout after the final item is pass/failed
					timeout: 5, //Initiated on final item 
					itemtype: 'items', //Labels your save types such as items, products, skus, parts
					finished: 0,
					percent: "0%",
					pass: 0,
					fail: 0,
					faillist: [], //Can take simple values,
					faillinks: [], //Can take links to things like items or products.
					timeoutid: false,
					errors: [] //Can take strings
				}));
			}
		}).catch(err => {
			//Error getting any response
			dispatch(newStatus({
				type: "requesterror",
				msg: 'Caught API request error.',
				show: true,
				settimeout: true, //This option allows for a timeout after the final item is pass/failed
				timeout: 5, //Initiated on final item 
				itemtype: 'items', //Labels your save types such as items, products, skus, parts
				finished: 0,
				percent: "0%",
				pass: 0,
				fail: 0,
				faillist: [], //Can take simple values,
				faillinks: [], //Can take links to things like items or products.
				timeoutid: false,
				errors: [] //Can take strings
			}));
		});
	}


	/* ############### RESIZER ####################*/
	const createResizableColumn = function (col, resizer) {
		// Track the current position of mouse
		let x = 0;
		let w = 0;

		const mouseDownHandler = function (e) {
			// Get the current mouse position
			x = e.clientX;
			// Calculate the current width of column
			const styles = window.getComputedStyle(col);
			w = parseInt(styles.width, 10);
			// Attach listeners for document's events
			document.addEventListener('mousemove', mouseMoveHandler);
			document.addEventListener('mouseup', mouseUpHandler);
		};

		const mouseMoveHandler = function (e) {
			// Determine how far the mouse has been moved
			const dx = e.clientX - x;
			// Update the width of column
			col.style.width = `${w + dx}px`;
		};

		// When user releases the mouse, remove the existing event listeners
		const mouseUpHandler = function () {
			document.removeEventListener('mousemove', mouseMoveHandler);
			document.removeEventListener('mouseup', mouseUpHandler);
		};
		resizer.addEventListener('mousedown', mouseDownHandler);
	};

	const InitColumnResizers = () => {
		//Runs after rerender
		// Query the table
		const table = document.getElementById('resizeMe');
		// Query thead:
		const thead = document.querySelector('thead');
		const cols = thead.querySelectorAll('td');
		// Loop over them
		[].forEach.call(cols, function (col) {
			// Create a resizer element
			const resizer = document.createElement('div');
			resizer.classList.add([classes.resizer]);
			// Set the height
			resizer.style.height = `${table.offsetHeight - 2}px`;
			// Add a resizer element to the column
			col.appendChild(resizer);
			createResizableColumn(col, resizer);
		});
	}

	/* ############### END OF RESIZER ####################*/




	/* ##########################  App Init  ########################## */
	//Run once, don't clean up until controller dismount (unchanging init variable)
	const [appinit] = useState(true);
	useEffect(() => {
		document.title = "Flex";
		//Cleanup
		return function cleanup() {
			dispatch(setStatusTimeout(0));
		}
	}, [appinit]);


	//DB Reloads
	useEffect(() => {
		if (state.dbreload) {
			dispatch(setCurrentMenuSection(configuration.menusection));
			dispatch(setCurrentMenuItem(configuration.menuitem));
			//Assuming we have all the config now loaded into view from URL params, we can clear out URL (fixes refresh issues)
			window.history.pushState(null, '', location.pathname);
			//Avoid duplicate loads.
			localstate.dbreload = false;
			LoadItems();
		} else {
			//console.log("Ignore DB Reload.");
			//Boostrap a resizer for the columns:
			if (localstate.griditems.length > 0 && localstate.configuration.viewmode==="grid"){
				InitColumnResizers();
			}
		}
	},);



	/* ##########################  CRUD  ########################## */

	//A Ref stays consistent throughout async function
	const requestcount = useRef(0);

	const SaveChanges = () => {
		//Configuration
		requestcount.current = 0;
		var timeout = 3000; //Seconds before closing final ProgressBar results - To Do: Add option to NOT timeout at all
		var requestinterval = 100; //Milliseconds

		var updatearray = [];
		//Data Validation and Update Array setup
		for (var i = 0; i < localstate.griditems.length; i++) {
			//Halt on bad Name
			if (localstate.griditems[i].Name === "" && localstate.griditems[i].unsaved) {
				dispatch(newErrorMessage({ errmsg: "One or more of your rows has a blank Name value.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setStatusTimeout(5000));
				//Old?
				// dispatch(setErrorTimeout(10));
				return;
			}
			if (localstate.griditems[i].unsaved) {
				updatearray.push(localstate.griditems[i]);
			}
		}

		//Make sure we don't timeout while updating:
		dispatch(setStatusTimeout(500000));

		if (updatearray.length > 0) {
			//DisableButtons();
			dispatch(newStatus({
				type: "progress",
				msg: 'Saving items...',
				show: true,
				settimeout: true, //This option allows for a timeout after the final item is pass/failed
				timeout: timeout, //Initiated on final item 
				itemtype: 'items', //Labels your save types such as items, products, skus, parts
				finished: 0,
				percent: "0%",
				total: updatearray.length,
				pass: 0,
				fail: 0,
				faillist: [], //Can take simple values,
				faillinks: [], //Can take links to things like items or products.
				timeoutid: false,
				errors: [] //Can take strings
			}));
			i = 0;
			var limit = updatearray.length - 1;
			/* INTERVAL */
			var updateitems = setInterval(function () {
				var item = updatearray[i];
				const postdata = {
					item: item,
					dbmodel: localstate.configuration.dbmodel,
					itemskey: localstate.configuration.itemskey
				};
				axios.post(dbendpoint + localstate.configuration.apiendpoint + "update", postdata, defaultpostoptions).then(res => {
					//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
					if (res.status === 200) {
						//If ValidateUser() fails to verify user, it sends back 'login' error. 
						if (res.data.Status === "login") {
							//Not logged in. Reload page causes redirect to /login
							window.location.reload(false);
						}
						if (res.data.Status === "Success") {
							//Success response also includes the item!
							//Try: 10-20-2023 - Should we access read-only DOM elements such CreatedBy? When we do an update, we're avoiding a reload of DB and rerender already..... This would be the icing on the cake even just for static items.
							//If we sent new rows, we'll need to reference the old ID.
							var itemindex = 0;
							if (res.data.OldID) {
								itemindex = localstate.griditems.map(function (o) { return o.ID; }).indexOf(res.data.OldID);
								localstate.griditems[itemindex].unsaved = false;
								rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.unsavedhighlight);
								rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.errorhighlight);
								//Set New ID
								localstate.griditems[itemindex].ID = res.data.item.ID;
							} else {
								itemindex = localstate.griditems.map(function (o) { return o.ID; }).indexOf(res.data.item.ID);
								localstate.griditems[itemindex].unsaved = false;
								//Refs allow us to update the grid live!
								rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.unsavedhighlight);
								rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.errorhighlight);
							}
							dispatch(incrementPass());
						}
						if (res.data.Status === "Failure") {
							//Failure error - To Do: Dispatch failure messages to the ProgressBar
							dispatch(incrementFail(res.data.message));
						}
						requestcount.current++;
						FinalizeRequest(requestcount.current, limit, timeout);

					} else {
						//Non-200 message from server.
						requestcount.current++;
						FinalizeRequest(requestcount.current, limit, timeout);
						dispatch(incrementFail("Non-200 response."));
					}
				}).catch(err => {
					//Non-200, 500 Error, timeout?
					//console.log(err);
					requestcount.current++;
					FinalizeRequest(requestcount.current, limit, timeout);
					dispatch(incrementFail("500 response."));
				});
				//If we have looped through all items, clear this interval.
				if (i === limit) {
					clearInterval(updateitems);
				}
				i++;
			}, requestinterval);
		} else {
			dispatch(newErrorMessage({ errmsg: "Nothing to save.", errshow: true, errtimeout: 5, errtype: "neutral" }));
			dispatch(setErrorTimeout(5));
			ResetPendingSaves();
		}
	}

	//Clean up View
	const FinalizeRequest = (i, limit, timeout) => {
		//The itterator after responses are incremented to n+1. Reversed below:
		if ((i - 1) === limit) {
			//EnableButtons();
			dispatch(setStatusTimeout(timeout));
			MarkErrorItems();
			btnSave.current.style.display = "flex";
			btnPendingSave.current.style.display = "none";
		}
	}


	//Mark Remaining Items as Warning Items
	const MarkErrorItems = () => {
		for (var i = 0; i < localstate.griditems.length; i++) {
			if (localstate.griditems[i].unsaved) {
				rowRefs.current[i + 'SaveStatus'].classList.remove(classes.unsavedhighlight);
				rowRefs.current[i + 'SaveStatus'].classList.add(classes.errorhighlight);
			} else {
				//Resolve previously unresolved
				rowRefs.current[i + 'SaveStatus'].classList.remove(classes.errorhighlight);
			}
		}
	}


	const ResetPendingSaves = () => {
		for (var i = 0; i < localstate.griditems.length; i++) {
			if (localstate.griditems[i].unsaved) {
				localstate.griditems[i].unsaved = false;
			}
		}
		//EnableButtons();
		//These buttons may not exist!
		if (configuration.allowresetsavebtn){
			btnSave.current.style.display = "flex";
			btnPendingSave.current.style.display = "none";
		}

	}


	{/* BULK EDIT DRAWER STATE AND FUNCTIONS */ }
	const [showbulkeditdrawer, setShowBulkEditDrawer] = useState(false);
	const btnApplyBulkEdit = useRef();

	const CloseBulkEditDrawer = () => {
		dispatch(setErrorTimeout(0));
		setShowBulkEditDrawer(false);
		//Reload DB
		localstate.dbreload = true;
		//Update State
		UpdateState(localstate);
	}

	//Bulk edits may incur many different types of changes.
	//Using state variables, we can allow the view to change between them.



	//// CHANGE TYPES - Controls change type and input viewables

	//NEW
	const [changetype, setChangeType] = useState(''); //Determines types that may be checked with validation from configuration.
	const [changefield, setChangeField] = useState(''); //Represents DB column

	//Validation Settings
	//text
	const [textminlength, setTextMinLength] = useState(0);
	const [textmaxlength, setTextMaxLength] = useState(65535); //Default max for TEXT type. Highly encourage assigning proper limits for things like Name, Address, Product Name, etc.
	//float
	const [floatmin, setFloatMin] = useState(0); //Default 0, prevent some issues here.
	const [floatmax, setFloatMax] = useState(1000000); //Default some huge number
	const [floatprecision, setFloatPrecision] = useState(2); //Default 2
	//integer
	const [intmin, setIntMin] = useState(0);
	const [intmax, setIntMax] = useState(1000000);
	//select
	const [selectoptions, setSelectOptions] = useState([
		{
			//Some default. Your configuration should be more complete than this.
			value: 0,
			label: "No"
		}
	]);
	const [defaultselect, setDefaultSelect] = useState([
		{
			value: 0,
			label: "No"
		}
	]);
	//customselect
	const [customselectoptions, setCustomSelectOptions] = useState([
		<MenuItem value={true}>True</MenuItem>,
		<MenuItem value={false}>False</MenuItem>,
	]);
	const [defaultcustomvalue, setDefaultCustomValue] = useState(false);
	//autocomplete
	const [autocompleteconfig, setAutoCompleteConfig] = useState({
		//Defaults to products table!
		searchtype: "products",
		searchby: "Name",
		saveas: "ProductID",
		optionkey: "ProductID", //Since field and saveas aren't always unique values, they're no good for keys we'd like to use from the DB
		childrelationship: true,
		nestedmodel: "product",
	});
	const [autocompletevalue, setAutoCompleteValue] = useState({
		value: null,
		Name: ""
	});
	//datetime
	const [datetimeconfig, setDateTimeConfig] = useState({
		//Default

	})


	//We may scrap a lot of these:
	const [changeisfloat, setChangeIsFloat] = React.useState(false);
	const [changeissomeselectable, setChangeIsSomeSelectable] = React.useState(false);
	const [changeisdbitem, setChangeIsDBItem] = React.useState(false);
	const [changeisdate, setChangeIsDate] = React.useState(false);
	const [changeisdatetime, setChangeIsDateTime] = React.useState(false);
	const [changeisbool, setChangeIsBool] = React.useState(false);
	const [changeisint, setChangeIsInt] = React.useState(false);
	const [changeisstatus, setChangeIsStatus] = React.useState(false);


	//// VALUES - Controls input values and value validation
	const changevalue = React.useRef(null);
	//These 2 refs are used to update a number input (RestrictNumber() will limit what can be put into input box)
	const changevaluefloat = React.createRef();
	const [dbitemselection, setDBItemSelection] = React.useState();


	const handleChangeEditType = (event) => {
		//Reset Btn
		btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
		btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);

		const selectedField = event.target.value;
		//console.log(selectedField);

		//console.log(localstate.configuration.bulkeditcolumns);
		//console.log('fields in bulkeditcolumns:', localstate.configuration.bulkeditcolumns.map(c => c.field));
		const selectedColumn = localstate.configuration.bulkeditcolumns.find(col => col.field === selectedField);
		//console.log(selectedColumn);
		//console.log(event.target.value);

		//Validation Settings - Actual Validation happens on ApplyBulkEdit
		//TEXT
		if (selectedColumn.changetype === "text") {
			setTextMinLength(selectedColumn.minlength);
			setTextMaxLength(selectedColumn.maxlength);
		}
		//FLOAT
		if (selectedColumn.changetype === "float") {
			//console.log('Asigning float value: ' + selectedColumn.minval);
			setFloatMin(selectedColumn.minval);
			setFloatMax(selectedColumn.maxval);
			setFloatPrecision(selectedColumn.precision)
		}
		//INTEGER
		if (selectedColumn.changetype === "integer") {
			setIntMin(selectedColumn.minval);
			setIntMax(selectedColumn.maxval);
		}
		//SELECT
		if (selectedColumn.changetype === "select") {
			setSelectOptions(selectedColumn.menuitems);
			setDefaultSelect(selectedColumn.defaultvalue);
		}
		//CUSTOM SELECT
		if (selectedColumn.changetype === "customselect") {
			setCustomSelectOptions(selectedColumn.customoptions);
			setDefaultCustomValue(selectedColumn.defaultvalue);
		}
		//AUTOCOMPLETE
		if (selectedColumn.changetype === "autocomplete") {
			setAutoCompleteConfig(selectedColumn);
			setAutoCompleteValue(selectedColumn.defaultvalue);
		}
		//DELETEITEMS
		if (selectedColumn.changetype === "deleteitems") {
			DeleteSelectedInit();
		}




		setChangeField(selectedField)
		setChangeType(selectedColumn.changetype)



		//Scrap this:


		// //Reset change value
		// changevalue.current = "";
		// //Reset Inputs:
		// setChangeIsText(false);
		// setChangeIsFloat(false);
		// setChangeIsSomeSelectable(false);
		// setChangeIsDBItem(false);
		// setChangeIsBool(false);

		// //Examples
		// setChangeIsInt(false);
		// setChangeIsStatus(false);
		// setChangeIsDate(false);
		// setChangeIsDateTime(false);



		// setChangeType(event.target.value);

		// if (
		// 	//Text values here.
		// 	event.target.value === "Name"
		// ) {
		// 	setChangeIsText(true);
		// }

		// if (event.target.value === "Cost" || event.target.value === "Price") {
		// 	setChangeIsFloat(true);
		// }

		// if (event.target.value === "SomeSelectable") {
		// 	setChangeIsSomeSelectable(true);
		// }

		// if (event.target.value === "NewCheckbox") {
		// 	setChangeIsBool(true);
		// }

		// if (event.target.value === "DBItem") {
		// 	setChangeIsDBItem(true);
		// }

		// if (event.target.value === "Date") {
		// 	setChangeIsDate(true);
		// }

		// if (event.target.value === "DateTime") {
		// 	setChangeIsDateTime(true);
		// }

		// //Unused Examples:
		// if (event.target.value === "LotID" || event.target.value === "SkidNumber") {
		// 	setChangeIsInt(true);
		// }

		// if (event.target.value === "Status") {
		// 	setChangeIsStatus(true);
		// }

		// if (event.target.value === "LotID" || event.target.value === "SkidNumber") {
		// 	setChangeIsInt(true);
		// }

	};

	const handleChangeBulkValue = (event) => {
		//console.log(event);

		{/* ##### TEXT ##### */ }
		if (changetype === "text") {
			changevalue.current = event.target.value;
			//Validation
			if (changevalue.current.length > textmaxlength) {
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(true, "warning", "Configuration only allows up to " + textmaxlength + " characters."));
			} else if (changevalue.current.length < textminlength) {
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(true, "warning", "Value must be at least " + textminlength + " characters."));
			} else {
				btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
				setValidationError(NewValidationError(false, "default", ""));
			}
		}

		{/* ##### FLOAT ##### */ }
		if (changetype === "float") {
			changevalue.current = event.target.value;
			//console.log(changevalue.current);
			//Validation

			const epsilon = 1e-9; // very small tolerance
			const scaled = changevalue.current * (10 ** floatprecision);

			//Warn if outside of precision.
			if (event.target.value === "") { //Blank value - Disable button
				changevalue.current = "0";
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(false, "default", ""));
			} else if (Math.abs(Math.round(scaled) - scaled) > epsilon) {
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(true, "warning", "Precision is only set to " + floatprecision + " decimal places."));
			} else if (changevalue.current > floatmax) {
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(true, "warning", "Values greater than " + floatmax + " can not be saved."));
			} else if (changevalue.current < floatmin) {
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(true, "warning", "Values less " + floatmin + " can not be saved."));
			} else {
				btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
				setValidationError(NewValidationError(false, "default", ""));
			}
		}

		{/* ##### INTEGER ##### */ }
		if (changetype === "integer") {
			changevalue.current = event.target.value;
			//console.log(changevalue.current);
			//Validation

			//const epsilon = 1e-9; // very small tolerance
			//const scaled = changevalue.current * (10 ** floatprecision);

			//Warn if outside of precision.
			if (event.target.value === "") { //Blank value - Disable button, USER CAN TRY "0" next time, more purposeful.
				changevalue.current = "0";
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(false, "default", ""));
			} else if (changevalue.current > intmax) {
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(true, "warning", "Values greater than " + intmax + " can not be saved."));
			} else if (changevalue.current < intmin) {
				btnApplyBulkEdit.current.classList.remove(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.add(["Mui-disabled"]);
				setValidationError(NewValidationError(true, "warning", "Values less " + intmin + " can not be saved."));
			} else {
				btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
				btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
				setValidationError(NewValidationError(false, "default", ""));
			}
		}


		{/* ##### SELECT ##### */ }
		if (changetype === "select") {
			//console.log(event.target.value);
			btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
			btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
			changevalue.current = event.target.value;
			setValidationError(NewValidationError(false, "default", ""));
		}

		{/* ##### CUSTOM SELECT ##### */ }
		if (changetype === "customselect") {
			//console.log(event.target.value);
			btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
			btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
			changevalue.current = event.target.value;
			setValidationError(NewValidationError(false, "default", ""));
		}



		{/* ##### CHECKBOX ##### */ }
		if (changetype === "checkbox") {
			changevalue.current = event.target.value;
		}

		{/* ##### DATETIME ##### */ }
		if (changetype === "datetime") {
			btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
			btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
			changevalue.current = dayjs(event);
			setValidationError(NewValidationError(false, "default", ""));
		}




		//console.log("******************************************************");
		//console.log(changevalue.current);


		// //Currency
		// if (changetype === "Cost" || changetype === "Price") {
		// 	var newvalue = RestrictInputNumber(event.target.value, changevalue.current, event, "float");
		// 	if (newvalue) {
		// 		changevalue.current = newvalue;
		// 		changevaluefloat.current.value = newvalue;
		// 	} else {
		// 		if (event.key === "Backspace") {
		// 			//If the newvalue doesn't have a decimal, but the old one did, we try to keep the decimal value by ignoring the ref.
		// 			if ((changevalue.current.indexOf(".") > -1)) {
		// 				changevalue.current = parseFloat(event.target.value).toFixed(2);
		// 			}
		// 		}
		// 	}
		// 	//Integers	
		// } else if (changetype === "LotID" || changetype === "SkidNumber") {
		// 	changevalue.current = RestrictInputNumber(event.target.value, changevalue.current, event, "positiveinteger");
		// 	//Updates view:
		// 	changevalueint.current.value = changevalue.current;

		// } else if (changetype === "NewCheckbox") {
		// 	// placeholder
		// 	changevalue.current = event.target.value;
		// } else if (changetype === "DateTime") {
		// 	changevalue.current = dayjs(event);
		// } else {
		// 	//Raw Values
		// 	changevalue.current = event.target.value;
		// }


	}

	const handleChangeBulkValueAutoComplete = (newvalue) => {
		//console.log("$$$$$$$$$$$$$$$$$$$$$$$$");
		//console.log(newvalue);
		//console.log(newvalue[autocompleteconfig.field]);

		btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
		btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);

		changevalue.current = newvalue[autocompleteconfig.field];


	}

	const handleChangeDBItem = (event, item) => {
		setDBItemSelection(item);
		//Allow bulk change to be saved
		btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
		btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
	}

	const handleChangeSomeSelectable = (event) => {
		changevalue.current = event.target.value;
		btnApplyBulkEdit.current.classList.remove(["Mui-disabled"]);
		btnApplyBulkEdit.current.classList.add(["MuiButton-containedPrimary"]);
	}


	//Search for DB Item (autocomplete) - Attempt to make this reusable! Setup endpoints as (env db dbendpoint/table/getautocomplete), see also ApplyBulkEdit
	const [dbitemkey, setDBItemKey] = useState("Name");
	const [opendbitemoptions, openDBItemOptions] = React.useState(false);
	const [dbitemoptions, setDBItemOptions] = React.useState([""]);
	const [loadingdbitemoptions, setLoadingDBItemOptions] = useState(false);
	const InitDBItemOptions = () => {
		if (dbitemoptions.length === 0) {
			//Load (up to limit) options
			DBItemSearch("");
		}
		openDBItemOptions(true);
	}

	const DBItemSearch = debounce(function (searchvalue) {
		setLoadingDBItemOptions(true);
		const postdata = {
			key: dbitemkey,
			search: searchvalue,
			limit: 20
		};
		//Provisions to reuse this search:
		var table = "";
		if (changetype === "Product") {
			table = "products";
		}
		if (changetype === "DBItem") {
			table = "basictable";
		}
		//Error such as "TypeError: Cannot read property 'filter' of undefined" means we aren't handling the response correctly or the response is malformed.
		axios.post(dbendpoint + "/" + table + "/getautocomplete", postdata, defaultpostoptions).then(res => {
			if (res.status === 200) {
				if (res.data.Status === "login") {
					window.location.reload(false);
				} else {
					setDBItemOptions(res.data.items);
					//console.log(res.data);
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(5));
			}
			setLoadingDBItemOptions(false);
		});
	}, 600);

	const NewValidationError = (show, errtype, message) => {
		if (show) {
			return (
				<div style={{ height: "26px", backgroundColor: errtype === "ok" ? "green" : (errtype === "warning" ? "orange" : "red"), color: "#FFF", textAlign: "left", paddingLeft: "5px", paddingRight: "5px", borderRadius: "3px", display: "inline-block" }}>
					{message}
				</div>
			)
		}
		if (!show) {
			//Placeholder for message
			return (
				<div style={{ height: "26px", width: "100%" }}>

				</div>
			)
		}
	}



	const [validationerror, setValidationError] = useState(NewValidationError(false, "default", ""));


	const ApplyBulkEdit = () => {
		//console.log(changevalue.current);
		//console.log(changevalue.current);
		//console.log(changevalue.current);
		//console.log(changevalue.current);
		var items = [];
		for (var i = 0; i < localstate.selectedindexes.length; i++) {
			items.push(localstate.griditems[localstate.selectedindexes[i]]);
		}


		// ######## VALIDATIONS ######
		if (changetype === "text") {
			//Settings are forwarded from the column configuration.
			// textminlength
			// textmaxlength
			if (changevalue.current.length >= textminlength && changevalue.current.length <= textmaxlength) {
				for (i = 0; i < items.length; i++) {
					items[i][changefield] = changevalue.current;
				}
			} else if (changevalue.current.length > textmaxlength) {
				setValidationError(NewValidationError(true, "warning", "Text must be at most " + textmaxlength + " characters."));
				return;
			} else if (changevalue.current.length < textminlength) {
				setValidationError(NewValidationError(true, "warning", "Text must be at least " + textminlength + " characters."));
				return;
			}
		}

		if (changetype === "float") {
			//console.log("Look at this");
			//console.log("changevalue.current: " + changevalue.current);
			var floatvalue = parseFloat(changevalue.current);
			if (floatvalue >= floatmin && floatvalue <= floatmax) {
				for (i = 0; i < items.length; i++) {
					//console.log("Assigning " + changefield + " to " + changevalue.current + " on " + i);
					items[i][changefield] = changevalue.current;
				}
			} else if (floatvalue > floatmax) {
				setValidationError(NewValidationError(true, "warning", "Value must be at most " + floatmax + " characters."));
				return;
			} else if (floatvalue < floatmin) {
				setValidationError(NewValidationError(true, "warning", "Value must be at least " + floatmin + " characters."));
				return;
			}
		}



		if (changetype === "select") {
			//console.log("Look at this");
			//console.log("changevalue.current: " + changevalue.current);
			for (i = 0; i < items.length; i++) {
				//console.log("Assigning " + changefield + " to " + changevalue.current + " on " + i);
				items[i][changefield] = changevalue.current;
			}
		}

		if (changetype === "customselect") {
			//console.log("Look at this");
			//console.log("changevalue.current: " + changevalue.current);
			for (i = 0; i < items.length; i++) {
				//console.log("Assigning " + changefield + " to " + changevalue.current + " on " + i);
				items[i][changefield] = changevalue.current;
			}
		}

		if (changetype === "autocomplete") {
			//console.log("Look at this");
			//console.log("changevalue.current: " + changevalue.current);
			for (i = 0; i < items.length; i++) {
				//console.log("Assigning " + changefield + " to " + changevalue.current + " on " + i);
				items[i][changefield] = changevalue.current;
			}
		}

		if (changetype === "datetime") {
			//console.log("Look at this");
			//console.log("changevalue.current: " + changevalue.current);
			for (i = 0; i < items.length; i++) {
				//console.log("Assigning " + changefield + " to " + changevalue.current + " on " + i);
				items[i][changefield] = changevalue.current;
			}
		}



		// //Database Item Selection (potential multiple values to change)
		// if (changetype === "DBItem") {
		// 	//Place your specific column values here:
		// 	for (i = 0; i < items.length; i++) {
		// 		items[i]["Name"] = dbitemselection.Name;
		// 		//Example: items[i]["ProductID"] = dbitemselection.ProductID;
		// 	}
		// }

		// //Reassign other item values if needed before pushing them to postdata.items.
		// //Example provision to change Margin if price or cost change
		// if (changetype === "Price") {
		// 	for (i = 0; i < items.length; i++) {
		// 		//items[i].Price = changevalue.current;
		// 		items[i].Margin = items[i].Price - items[i].Cost;
		// 	}
		// }

		// if (changetype === "Cost") {
		// 	for (i = 0; i < items.length; i++) {
		// 		//items[i].Cost = changevalue.current;
		// 		items[i].Margin = items[i].Price - items[i].Cost;
		// 	}
		// }

		// if (changetype === "Date") {
		// 	//Verify if Date is valid:
		// 	var count = (changevalue.current.match(/-/g) || []).length;
		// 	if (changevalue.current.length === 10 && count === 2) {
		// 		let isValidDate = Date.parse(changevalue.current);
		// 		if (isNaN(isValidDate)) {
		// 			dispatch(newErrorMessage({ errmsg: "Not a valid date for audit. Use YYYY-MM-DD.", errshow: true, errtimeout: 5, errtype: "warning" }));
		// 			dispatch(setErrorTimeout(10));
		// 			return;
		// 		} else {
		// 			//Function Continues to post
		// 		}
		// 	} else {
		// 		dispatch(newErrorMessage({ errmsg: "Not a valid date for audit. Use YYYY-MM-DD.", errshow: true, errtimeout: 5, errtype: "warning" }));
		// 		dispatch(setErrorTimeout(10));
		// 		return;
		// 	}
		// 	for (i = 0; i < items.length; i++) {
		// 		if (changeisdate) {
		// 			items[i]['BulkEditDate'] = true;
		// 		}
		// 	}
		//	}

		//Use a different Datetime keyvalue:
		if (changetype === "DateTime") {
			//Place your specific column values here:
			for (i = 0; i < items.length; i++) {
				items[i]["Date"] = changevalue.current;
			}
		}

		var postdata = {
			items: items,
			dbmodel: localstate.configuration.dbmodel,
			itemskey: localstate.configuration.itemskey,
			changefield: changefield,
			changevalue: changevalue.current

		}



		axios.post(dbendpoint + localstate.configuration.apiendpoint + "bulkedititems", postdata, longpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === 'login') {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				if (res.data.Status === 'Success') {
					//console.log(res.data);
					if (res.data['SuccessCount'] > 0) {
						// dispatch(newErrorMessage(
						// 	{
						// 		errmsg: "Items Changed: " + res.data['SuccessCount'] + ", Failures: " + res.data['FailCount'],
						// 		errshow: true,
						// 		errtimeout: 5,
						// 		errtype: 'ok'
						// 	}
						// ));
						// dispatch(setErrorTimeout(30));
						setValidationError(NewValidationError(true, "ok", "Items changed: " + res.data['SuccessCount'] + ", Failures: " + res.data['FailCount']));
					}
				}
				if (res.data.Status === 'Failure') {
					//Failure error
					setValidationError(NewValidationError(true, "failure", "Request failed."));
				}
			} else {
				//Non-200 message from server.
				setValidationError(NewValidationError(true, "failure", "API Error."));
			}
		});
	}



	//Delete Confirmation and Deletion
	const [showdeleteconfirmation, setShowDeleteConfirmation] = useState(false);
	const [deleteitems, setDeleteItems] = useState([]);
	const DeleteSelectedInit = () => {
		var deleteitemsarray = [];
		//Reflect items to user for confimation.
		for (var i = 0; i < localstate.selectedindexes.length; i++) {
			deleteitemsarray.push(localstate.griditems[localstate.selectedindexes[i]]);
		}
		console.log("DeleteSelected()");
		console.log("Array:" + deleteitemsarray);
		//Commit localstate to state before message renders!
		UpdateState(localstate);
		setDeleteItems(deleteitemsarray);
		setShowDeleteConfirmation(true);
	}

	const DeleteSelected = () => {
		CloseBulkEditDrawer();
		var finishedrequests = 0;
		for (var i = 0; i < localstate.selectedindexes.length; i++) {
			//Make Delete request to DB
			const postdata = {
				dbmodel: localstate.configuration.dbmodel,
				item: localstate.griditems[localstate.selectedindexes[i]],
				itemskey: localstate.configuration.itemskey
			};
			axios.post(dbendpoint + "/flexigrid/delete", postdata, longpostoptions).then(res => {
				//No matter the response, we consider the result as a 'finished request'. We can then properly do clean-up.
				finishedrequests++;
				//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
				if (res.status === 200) {
					//If ValidateUser() fails to verify user, it sends back "login" error. 
					if (res.data.Status === "login") {
						//Not logged in. Reload page causes redirect to /login
						window.location.reload(false);
					}
					if (res.data.Status === "Success") {
						//Success response also includes the item!
						//If we're pulling the item out of grid items, we'll use the ID of the item for reference.
						if (res.data.OldID) {
							//Since griditems state can be reloaded anytime, we look for the indexOf the ID
							var itemindex = localstate.griditems.map(function (o) { return o.ID; }).indexOf(res.data.OldID);
							localstate.griditems.splice(itemindex, 1);
							//Remove selected index as well?
						} else {
							dispatch(newErrorMessage({ errmsg: "Could not delete one or more items.", errshow: true, errtimeout: 8, errtype: "warning" }));
							dispatch(setErrorTimeout(5));
						}
					}
					if (res.data.Status === "Failure") {
						//Failure error
						dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "neutral" }));
						dispatch(setErrorTimeout(5));
						//Need to clear selections as any removed grid items will mess with selectedindexes.
						//Setting selected indexes to a blank array will stall the upper for-loop
						localstate.selectedindexes = [];
						localstate.selectedcount = 0;
						for (var j = 0; j < localstate.griditems.length; j++) {
							localstate.griditems[j].isSelected = false;
							localstate.griditems[j].GridKey++;
						}
						UpdateState(localstate);
					}
				} else {
					//Non-200 message from server.
					dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
					dispatch(setErrorTimeout(5));
				}
				//After result from last request, do cleanup.
				if (finishedrequests === localstate.selectedindexes.length) {
					//Clear out all selections! Since checkboxes are controlled only by grid items index, we don't have good
					//tracking on which items are which.
					localstate.selectedindexes = [];
					localstate.selectedcount = 0;
					UpdateState(localstate);
					setShowDeleteConfirmation(false);
					CloseViewEditMenu();
				}
			});

		}
	}
	const CancelDelete = () => {
		setChangeField('')
		setChangeType('')
		setShowDeleteConfirmation(false);
	}

	const GoToItem = (id) => {
		history.push('/boilerplatekeyvalues/' + id);
	}


	/* ##########################  Cell Interaction  ########################## */


	//Tab Order: Used for horizontal tabbing below.
	//We need an order for horizontal tabbing - attempting to tab to an unavailable column (like a disabled column via colstate) will result in an error
	const taborder = localstate.configuration.taborder; //["Name", "Cost","PositiveInteger", "Price"];


	//Excel-like functionality for grid
	const HandleKeyDown = (event, index, column) => {


		console.log("taborder:", taborder);
console.log("column.field:", column.field);
console.log("colstate:", colstate);
console.log("available refs:", Object.keys(rowRefs.current));

		//Deny Decimals for Integer inputs!
		console.log("Key: " + event.key);
		if (event.key === "." && column.field === "PositiveInteger") {
			console.log("Prevent decimal in integer input");
			event.preventDefault();
		}
		//Handle Tabs!
		if (event.key === "Tab") {
			event.preventDefault();
			//Vertical VS Horizontal Tabbing
			console.log(column.field);

			//Vertical Tabbing - Checkboxes, Gross Income, Rates
			//Vertical Tabbing is never subject to the next column not being shown (we always to back to record #1 instead!)
			if (column.field === "Checkbox") {  //Insert each type of column you want vertically tabbed here: if (column==="Checkbox" || column==="Margin"){ etc
				//If the next row ref exists....
				if (rowRefs.current[(index + 1) + column.field]) {
					rowRefs.current[(index + 1) + column.field].focus();
				} else {
					//Go to first element
					rowRefs.current[("0" + column.field)].focus();
				}
			} else {
				//Horizontal Tabbing - Row Data
				//Horizontal Tabbing is subject to certain columns not being available for selection. (not visbile)

				// If taborder is empty or current column is not in taborder, do nothing (or fallback)
				if (!Array.isArray(taborder) || taborder.length === 0) {
					console.warn("Tab pressed but taborder is empty");
					return;
				}

				var tabindex = taborder.indexOf(column.field);
				if (tabindex === -1) {
					console.warn("Current column not in taborder:", column.field);
					return;
				}

				// Increase index until we find the next tab order column
				for (var i = (tabindex + 1); i < taborder.length + 1; i++) {
					//If we're at the last column element, go to the next row's first available column element
					if (i === taborder.length) {
						//Start at beginning of row tab order and reitterate
						i = -1;
						//If next row exists:
						if (rowRefs.current[(index + 1) + column.field]) {
							index = index + 1;
						} else {
							//Go to first row.
							index = 0;
						}
					} else {
						//If there is another element in the taborder.... Continue. Else, go to first column.
						if (taborder[i]) {
							//If that next element is available
							// if (colstate[taborder[i]]) {
							// 	rowRefs.current[index + taborder[i]].select();
							// 	break;
							// }
							if (column.visible) {
								rowRefs.current[index + taborder[i]].select();
								break;
							}
						} else {
							//Start at beginning of row tab order and reitterate
							i = -1;
						}
					}
				}
			}
		}
		//Handle Down Arrow
		if (event.key === "ArrowDown") {
			event.preventDefault();
			if (rowRefs.current[(index + 1) + column.field]) {
				rowRefs.current[(index + 1) + column.field].focus();
			} else {
				//Go to first element
				rowRefs.current[("0" + column.field)].focus();
			}
		}
		//Handle Up Arrow
		if (event.key === "ArrowUp") {
			event.preventDefault();
			if (rowRefs.current[(index - 1) + column.field]) {
				rowRefs.current[(index - 1) + column.field].focus();
			} else {
				//Go to last element
				var lastelement = localstate.griditems.length - 1;
				rowRefs.current[(lastelement + column.field)].focus();
			}
		}
		//Handle Right Arrow - Special cases, normally ignored to be used for cursor position:
		/*
		if (event.key === "ArrowRight"){
			event.preventDefault();
			//Same Process as Tab
			var tabindex = taborder.indexOf(column);
			for (var i = (tabindex + 1); i < taborder.length + 1; i++) {
				if (i === taborder.length) {
					i = -1;
					if (rowRefs.current[(index + 1) + column]) {
						index = index + 1;
					} else {
						index = 0;
					}
				} else {
					if (taborder[i]) {
						if (colstate[taborder[i]]) {
							rowRefs.current[index + taborder[i]].select();
							break;
						}
					} else {
						i = -1;
					}
				}
			}
		}
		//Handle Left Arrow
		if (event.key === "ArrowLeft"){
			event.preventDefault();
			var tabindex = taborder.indexOf(column);
			var i;
			var rowincrement=0;
			for (i=(tabindex-1); i>-2; i--){
				if (i===-1){
					rowincrement=-1;
					i=taborder.length; //Go to end of tab order
				} else {
					if (colstate[taborder[i]]) {
						break;
					}
				}
			}
			//If tabindex first and we're in the first row, go to the last element on last row.
			if (tabindex===0 && index===0){
				var lastindex = localstate.griditems.length-1;
				rowRefs.current[lastindex + taborder[i]].select();
			} else {
				rowRefs.current[(index+rowincrement) + taborder[i]].select();
			}
		}
		*/
	}


	const DetectBlankNumber = (event, index, column) => {
		if (event.target.value === "") {
			rowRefs.current[index + column].value = "0.00";
			localstate.griditems[index][column] = "0.00";
		}
	}

	const DetermineDirtyStatus = (index) => {
		//Current Row
		//AI Logic for rowdirty:
		const currentRow = localstate.griditems[index];
		const defaultRow = localstate.defaultvalues[index];
		const columns = localstate.configuration.columns.filter(c => c.visible);

		// console.log(currentRow);
		// console.log(defaultRow);
		// console.log(columns);
		if (isRowDirty(currentRow, defaultRow, columns)) {
			//Dirty:L
			//console.log("dirty");
			rowRefs.current[index + "SaveStatus"].classList.add(classes.unsavedhighlight);
			//btnPendingSave.current.style.display = "flex";
			localstate.griditems[index].unsaved = true;
		} else {
			//console.log("OOKOKOKOKOKOK");
			rowRefs.current[index + "SaveStatus"].classList.remove(classes.unsavedhighlight);
			//btnPendingSave.current.style.display = "none";
			localstate.griditems[index].unsaved = false;
		}

		//Whole Form
		var dirty = false;
		for (var i = 0; i < localstate.griditems.length; i++) {
			if (localstate.griditems[i].unsaved) {
				dirty = true;
			}
		}
		if (dirty) {
			btnSave.current.style.display = "none";
			btnPendingSave.current.style.display = "flex";
		} else {
			btnSave.current.style.display = "flex";
			btnPendingSave.current.style.display = "none";
		}
	}

	//Cell Value Change
	const onChangeValue = (event, index, column) => {
		// console.log(column);
		// console.log(localstate.griditems[index][column.field]);
		var oldvalue = localstate.griditems[index][column.field];
		var newvalue = event.target.value;
		// console.log("Event value:" + event.target.value);
		// console.log("Raw:" + newvalue);
		if (event.key !== "Tab" &&
			event.key !== "ArrowDown" &&
			event.key !== "ArrowUp" &&
			event.key !== "ArrowLeft" &&
			event.key !== "ArrowRight" &&
			event.key !== "ShiftLeft" &&
			event.key !== "ShiftRight"
		) {
			//Conditionals for Types:
			//Validation and Guardrails:

			//Text - The most basic and uninhibiting.
			//Potential for adding more validation if needed, maxlen, avoid certain characters....
			if (column.validationmethod === "text") {
				localstate.griditems[index][column.field] = newvalue;
			}

			//Positive Decimal 2 Places:
			if (column.validationmethod === "positivedecimal2") {
				if (!oldvalue) {
					//console.log("No old value.");
					oldvalue = "0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "float"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					rowRefs.current[index + column.field].value = newvalue;
					localstate.griditems[index][column.field] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = rowRefs.current[index + column.field];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					// console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					// console.log(parseFloat(event.target.value).toFixed(2));
					localstate.griditems[index][column.field] = parseFloat(event.target.value).toFixed(2);
				}
			}

			//Positive integers don't need decimals! Try to preventDefault on input on keydown.
			if (column.validationmethod === "positiveinteger") {
				if (!oldvalue) {
					oldvalue = "0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "positiveinteger"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					rowRefs.current[index + column.field].value = newvalue;
					localstate.griditems[index][column.field] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = rowRefs.current[index + column.field];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					//console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					localstate.griditems[index][column.field] = parseInt(event.target.value);
				}
			}


			//Checkbox
			if (column.validationmethod === "checkbox") {
				if (event.target.checked) {
					//console.log("Checked = true");
					localstate.griditems[index][column.field] = 1;
					//UpdateState(localstate);
				} else {
					//console.log("Checked = false");
					localstate.griditems[index][column.field] = 0;
					//UpdateState(localstate);
				}
			}



			//Selects already render the correct and unsaved result of selecting. (but right now they cause rerender via state.... possible change here.)
			if (column.field === "NewCheckbox") { //MaterialUI Checkbox
				if (event.target.checked) {
					localstate.griditems[index][column.field] = 1;
				} else {
					localstate.griditems[index][column.field] = 0;
				}
			}
			if (column.validationmethod === "select") {
				//Avoids Refs! Required for numeric input and seletables. Component takes care of view while localstate has yet to update the DB
				localstate.griditems[index][column.field] = newvalue;
			}






			//Optional Function from Configuration to run after an update:
			//console.log("############################");
			if (column.hasOwnProperty("onChange")) {
				//console.log(localstate);
				column.onChange({ localstate, index, column, rowRefs }); //Extend if needed.
			}


			//localstate.griditems[index].unsaved = true;


			DetermineDirtyStatus(index);

		}
	}

	const onChangeAutoCompleteValue = (index, column, newvalue) => {
		//Logic for changes is handled inside the auto-complete function (passed directly into griditems)
		//We still must determine dirty status!
		// console.log("SAVE AS: ")
		// console.log(newvalue[column.saveas]);
		localstate.griditems[index][column.saveas] = newvalue[column.saveas];
		DetermineDirtyStatus(index);
		//console.log(newvalue);
	}

	//We'll attempt to reuse our autocomplete inside bulkedits!
	const onChangeAutoCompleteValueBulkEdit = (index, column, newvalue) => {
		//console.log(newvalue);
	}


	/* ##########################  Button Functions  ########################################################################################################################################################### */
	/* ######################################################################################################################################################################################################### */

	const ExpandRowToggle = (index) => {
		localstate.griditems[index].ExpandRow = !localstate.griditems[index].ExpandRow;
		UpdateState(localstate);
	}

	const ExpandAll = () => {
		for (var i = 0; i < localstate.griditems.length; i++) {
			localstate.griditems[i].ExpandRow = true;
		}
		CloseViewOptionsMenu();
		UpdateState(localstate);
	}

	const SetView = (viewmode) => {
		localstate.configuration.viewmode = viewmode;
		localstate.dbreload = true; //You must reload. Indexes may be missing depending on what the search parameters are.
		UpdateState(localstate);
	}


	function getRandomInt(max) {
		return Math.floor(Math.random() * Math.floor(max));
	}

	//Export Confirmation and Exports
	const [showexportconfirmation, setShowExportConfirmation] = useState(false);
	//Chooses between "selected" or "searchresults"
	const [exporttype, setExportType] = useState("");
	//Export Message
	const [exportmessage, setExportMessage] = useState("");
	var exportmode = "";
	var exportlimit = configuration.exportoptions.limit;
	var exportfilename = configuration.exportoptions.filename;

	const InitExport = (exporttype) => {
		if (exporttype === "selected" && localstate.selectedindexes.length === 0) {
			//Do nothing
		} else {
			//Show export type selection
			setShowExportConfirmation(true);
			//Set export by "selected" or "searchresults"
			setExportType(exporttype);
			if (exporttype === "selected") {
				setExportMessage("");
			}
			if (exporttype === "searchresults") {
				setExportMessage("Exports of search results will be limited to " + exportlimit + " rows.");
			}
		}
	}

	const PrepareExport = (exportcfg) => {
		//Set global
		//alert(mode);
		//exportmode = exportcfg.label;
		var exportdata = [];
		var clonedata = [];
		if (exporttype === "selected") {
			//Need to DEEP clone:
			var clonedata = JSON.parse(JSON.stringify(localstate.griditems))
			//Push only selected indexes
			for (var i = 0; i < localstate.selectedindexes.length; i++) {
				exportdata.push(clonedata[localstate.selectedindexes[i]]);
			}
			console.log(exportcfg);
			//If this particular configuration needs mutation, do it now
			if (exportcfg.mutatedata){
				//console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
				exportdata = exportcfg.mutatedata(exportdata);
			}
			Export(exportdata, exportcfg);
		}
		if (exporttype === "searchresults") {
			//Prepare Searchpairs - You may need to follow this pattern in PrepareExport()
			//Need to DEEP clone:
			//console.log(localstate);
			var clonedsearchpairs = JSON.parse(JSON.stringify(localstate.searchoptions.searchpairs));

			//console.log(clonedsearchpairs);
			//Create new set which will only have up to activesearchescount searchpairs added.
			var newsearchpairs = {};

			//AUTOCOMPLETE AND SELECT Handler
			//The SearchTools controller will treat any search with multiple=true as an ormode with merged array values. 
			for (var i = 1; i < (activesearchescount + 1); i++) {
				newsearchpairs["searchpair" + i] = clonedsearchpairs["searchpair" + i];
				//Products Autocomplete
				if (clonedsearchpairs["searchpair" + i].mode === "autocomplete" && clonedsearchpairs["searchpair" + i].type === "products") {
					newsearchpairs["searchpair" + i].type = "ProductID";
					//Note: You may change the "mode" and possibly rely on SearchTools to handle an array (if detected!)
					//We don't normally change the mode, instead allowing our TableController to handle special auto-completed values, normally relationship based values.
					//To simplify same-layer table values such as "ProductID", we might leverage our already working ormode code to handle an array value!
					//Test a new non-short circuited ProductID search using mode="like" in SkusTable.js
				}
				//.... More Rules
				//Some select mode items may be converted to "like"
			}

			const postdata = {
				searchoptions: {
					//Set Max Limit Here
					limit: exportlimit,
					currentsort: localstate.orderby,
					currentsortdir: localstate.order,
					searchpairs: newsearchpairs,
					itemskey: localstate.configuration.itemskey,
					dbmodel: localstate.configuration.dbmodel,
					nestedrelationships: localstate.searchoptions.nestedrelationships,
					viewdeleted: localstate.searchoptions.viewdeleted,
					//DB table supports:
					//Try to give all new tables these supports:
					softdeletesupport:localstate.configuration.softdeletesupport,
					creationusersupport:localstate.configuration.creationusersupport,
					updateusersupport:localstate.configuration.updateusersupport,
					deleteusersupport:localstate.configuration.deleteusersupport,
					//Datetimes
					datetimes:localstate.configuration.datetimes
				}
			};
			//localstate.configuration.apiendpoint
			axios.post(dbendpoint + localstate.configuration.apiendpoint + "getitems?page=" + (localstate.page + 1), postdata, defaultpostoptions).then(res => {
				if (res.status === 200) {
					if (res.data.Status === "login") {
						window.location.reload(false);
					}
					if (res.data.Status === "Success") {
						exportdata = res.data.pagedata.data;
						//Same mutation for views
						if (localstate.configuration.mutatedata){
							exportdata = localstate.configuration.mutatedata(exportdata); 
						}

		
						if (exportcfg.mutatedata){
							//console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
							exportdata = exportcfg.mutatedata(exportdata); 
						}




						Export(exportdata, exportcfg);
					}
					if (res.data.Status === "Failure") {
						dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "neutral" }));
						dispatch(setErrorTimeout(5));
					}
				} else {
					dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
					dispatch(setErrorTimeout(5));
				}
			});
		}
	}

	function RemoveColumns(columns, exportcfg) {
		if (!exportcfg || !exportcfg.removevalues) return columns;
		return columns.filter(col => !exportcfg.removevalues.includes(col.column));
	}

	/**
 * Export array of objects to CSV using a column config array.
 * Supports nested properties and custom headers.
 * 
 * @param {Array} data - Array of data objects
 * @param {Array} columns - Array of {column, label} config objects
 * @param {String} filename - Output file name (without .csv)
 */
	function exportToCSV(data, columns, filename = "export") {
		//console.log(columns);
		// Validate columns
		columns.forEach((col, idx) => {
			if (!col.column) {
				console.warn(`Column config at index ${idx} is missing the 'column' property.`);
			}
		});

		// SYLK workaround: Excel will misinterpret if first column is "ID"
		let headers = columns.map(col => col.label || col.column);
		if (headers[0] === "ID") {
			headers[0] = "UniqueID";
		}

		// Helper: get nested value using dot notation
		function getValue(obj, path) {
			if (typeof path !== "string" || !path.length) return "";
			return path.split('.').reduce((acc, part) => acc && acc[part], obj);
		}

		// Build CSV rows
		let csvRows = [];

		// Header row
		csvRows.push(headers.join(','));

		// Data rows
		for (let i = 0; i < data.length; i++) {
			let row = columns.map(col => {
				let value = getValue(data[i], col.column);
				// If dateFormat, format with dayjs
				if (col.dateFormat && value) {
					value = dayjs(value).format(col.dateFormat);
				}

				// Quote value, escape quotes
				if (value == null) value = "";
				if (typeof value === "string") {
					value = `"${value.replace(/"/g, '""')}"`;
				}
				return value;
			});
			csvRows.push(row.join(','));
		}

		// Combine to single CSV string
		let CSV = csvRows.join('\r\n');

		// Download in browser
		let uri = 'data:application/csv;charset=utf-8,' + encodeURIComponent(CSV);
		let link = document.createElement("a");
		link.href = uri;
		link.style = "visibility:hidden";
		link.download = filename + ".csv";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	const Export = (exportdata, exportcfg) => {
		// //Remove Metas
		// for (var i = 0; i < exportdata.length; i++) {
		// 	removeProp(exportdata[i], "isSelected");
		// 	removeProp(exportdata[i], "unsaved");
		// 	removeProp(exportdata[i], "ExpandRow");
		// 	removeProp(exportdata[i], "GridKey");
		// }

		// //Use Export Type to pare data
		// if (exportmode === "simple") {
		// 	for (var i = 0; i < exportdata.length; i++) {
		// 		removeProp(exportdata[i], "Date");
		// 		removeProp(exportdata[i], "created_at");
		// 		removeProp(exportdata[i], "updated_at");
		// 	}
		// }

		// if (exportmode === "expanded") {
		// 	for (var i = 0; i < exportdata.length; i++) {
		// 		removeProp(exportdata[i], "created_at");
		// 		removeProp(exportdata[i], "updated_at");
		// 	}
		// }

		// if (exportmode === "exhaustive") {
		// 	//Remove nothing - or possibly break down nested relationships
		// }


		//Use new config!
		// const columns = localstate.configuration.exportoptions.columns;

		// // Build header row
		// const header = columns.map(col => col.label || col.column);

		// // Build data rows
		// const rows = exportdata.map(row =>
		// 	columns.map(col => {
		// 		const value = getValue(row, col.column);
		// 		// Escape double quotes and commas
		// 		if (typeof value === "string") {
		// 			return `"${value.replace(/"/g, '""')}"`;
		// 		}
		// 		return value ?? '';
		// 	})
		// );

		// // Combine rows
		// const csvArray = [header, ...rows];
		// //return csvArray.map(row => row.join(",")).join("\n");

		// ExportCSV(csvArray, exportfilename);
		//const configuredexporttypes = localstate.configuration.exportoptions.exporttypes.find(type => type.type === exportcfg.type);
		const filteredColumns = RemoveColumns(localstate.configuration.exportoptions.columns, exportcfg);
		exportToCSV(exportdata, filteredColumns, localstate.configuration.exportoptions.filename);

		CloseExportMenu();
		setShowExportConfirmation(false);
	}


	/* ########################## Lower Screen Demo Data/Functions ###### */


	//Basic Select
	const [basicselectvalue, setBasicSelectValue] = React.useState(10);

	const handleChange = (event) => {
		setBasicSelectValue(event.target.value);
	};


	//Autocomplete Simple
	//Example: Products
	const [openproductoptions, openProductOptions] = React.useState(false);
	const [productoptions, setProductOptions] = React.useState([""]);
	const [loadingproductoptions, setLoadingProductOptions] = useState(false);
	const [productsearchterm, setProductSearchTerm] = useState("");
	//For loading single items that do have a value, use LoadItem function in conjunction with: setProductSearchTerm(res.data.item.product.Name);
	const InitProductOptions = () => {
		if (productoptions.length === 0) {
			ProductSearch("");
		}
		openProductOptions(true);
	}

	const onChangeProductOption = (event, newvalue) => {
		//Set value for current search
		// Example:
		// localstate.searchoptions.searchpairs.searchpairX.type=autocompletesearchtypeX;
		// localstate.searchoptions.searchpairs.searchpairX.value=newvalue[autocompletesearchtypeX];
		// localstate.dbreload = true;
		// UpdateState(localstate);

		//Or set value for your item:
		//localstate.itemdata['ProductID'] = newvalue['ProductID'];
		// localstate.pendingsaves = true;
		// btnSave.current.disabled = false;
		// btnSave.current.style.color="white";
		// btnSave.current.style.backgroundColor="#01579B";

		//Or just yell at the user, the ProductID they just set
		//alert(newvalue['ProductID']);



	}

	const ProductSearch = debounce(function (searchvalue) {
		setProductSearchTerm(searchvalue);
		setLoadingProductOptions(true);
		const postdata = {
			search: searchvalue,
			limit: 20
		};
		axios.post(dbendpoint + "/items/searchproducts", postdata, defaultpostoptions).then(res => {
			if (res.status === 200) {
				if (res.data.Status === "login") {
					window.location.reload(false);
				}
				if (res.data.Status === "Success") {
					setProductOptions(res.data.items);
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(5));
			}
			setLoadingProductOptions(false);
		});
	}, 600);

	const [basicselectdbvalue, setBasicSelectDBValue] = useState("");



	//Let's try to set a default value for our AutoComplete
	const [testDBAC, setDBAC] = useState('Some UseState Default');

	const onDBAutoCompleteChange = (newvalue, searchkey) => {
		//We can parse results by using keys - this makes the function reusable so we can insert many DBAutoComplete Components
		if (searchkey === "Vendor") {
			//console.log("Set new value: " + newvalue.Vendor);
			setDBAC(newvalue.Vendor);
		}
	}


	/* ##########################  Column Configuration  ####################################################################################################################################################### */
	/* ######################################################################################################################################################################################################### */



	{/* Utility Drawer state and functions */ }
	const [showutilitydrawer, setShowUtilityDrawer] = useState(false);

	const CloseUtilityDrawer = () => {
		setShowUtilityDrawer(false);
		//Reload DB?
		//localstate.dbreload = true;
		//Update State?
		//UpdateState(localstate);
	}

	const OpenUtilityDrawer = () => {
		CloseViewOptionsMenu();
		CloseViewEditMenu();
		setShowUtilityDrawer(true);
	}

	{/* Item List - General purpose boilerplate */ }
	const [showitemlist, setShowItemList] = useState(false);
	//We keep our original item list intact, use itemlistsearch for new DB reload
	const [itemlistsearch, setItemListSearch] = useState("");
	const [dupeitems, setDupeItems] = useState('');
	const CloseItemList = () => {
		//Get unique items
		const result = localstate.searchoptions.itemlist.split(/\r?\n/).filter(element => element);
		const newitemlist = GetUniqueArray(result);
		setItemListSearch(newitemlist);
		setShowItemList(false);

		//Reload DB
		localstate.dbreload = true;
		//Update State
		UpdateState(localstate);
	}

	const [itemlisttitle, setItemListTitle] = useState(""); //User's will need to know what is going on here.
	const [itemlistdescription, setItemListDescription] = useState(""); //Users will need to be told what to search by.
	const [itemlistkey, setItemListKey] = useState(""); //DB will need to know what to search by
	const SetItemList = (button) => {
		//alert(button.description);
		setItemListTitle(button.title);
		setItemListDescription(button.description);
		setItemListKey(button.itemlistkey);
		setShowItemList(true);
	}



	const onChangeItemList = (event) => {
		//Optional check for dupes:
		//Bust apart by line breaks!
		//Let's start sending arrays to PHP Laravel instead where possible since we're already
		//going to do work here before the API call.

		//If there is a line break at the end of the list (blank new line), you may end up with a falsy array element at the end.
		//Filter creates a new array based on passing a test function (true or false).
		//By passing a falsy array element (undefined), it won't return that element in the result array.
		//Split by Line Breaks, then filter.
		const result = event.target.value.split(/\r?\n/).filter(element => element);
		//Find Dupes, let the user know there are dupes.
		const dupes = GetDupeArray(result);
		if (dupes.length > 0) {
			setDupeItems(dupes);
			//console.log(dupes);
		} else {
			setDupeItems('');
		}
		localstate.searchoptions.itemlist = event.target.value;
		//setItemList(event.target.value);
	}

	{/* Print Labels */ }
	const PrintLabels = () => {
		var itemids = [];
		//Grab all IDs
		for (var i = 0; i < localstate.selectedindexes.length; i++) {
			itemids.push(localstate.griditems[localstate.selectedindexes[i]]['ID']);
		}

		var params = {
			itemids: JSON.stringify(itemids),
			labeltype: 'basiclabel',
			autoclose: false,
			seriallist: '',
			orderby: localstate.orderby,
			order: localstate.order
		};

		// Creating a form
		var form = document.createElement("form");
		form.setAttribute("method", "post");
		form.setAttribute("action", "../v3/labels");
		form.setAttribute("target", "NewLabel");
		for (var i in params) {
			if (params.hasOwnProperty(i)) {
				// Creating the input
				var input = document.createElement('input');
				input.type = 'hidden';
				input.name = i;
				input.value = params[i];

				// Attach input to form
				form.appendChild(input);
			}
		}
		document.body.appendChild(form);
		form.submit();
	}


	//Some requests might take longer
	const longpostoptions = {
		withCredentials: true,
		withXSRFToken: true,
		crossDomain: true,
		mode: "no-cors",
		timeout: 20000,
	};


	//Use these values for StatusBar
	var tablebuttonstyle = {
		padding: { xs: "2px 4px 0px 4px", sm: "3px 4px 2px 4px", md: "5px 4px 3px 4px", lg: "5px 5px 2px 5px" },       // px (theme spacing units)
		fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' },
	};



	/* 
				░█████████                               ░██                     
				░██     ░██                              ░██                     
				░██     ░██  ░███████  ░████████   ░████████  ░███████  ░██░████ 
				░█████████  ░██    ░██ ░██    ░██ ░██    ░██ ░██    ░██ ░███     
				░██   ░██   ░█████████ ░██    ░██ ░██    ░██ ░█████████ ░██      
				░██    ░██  ░██        ░██    ░██ ░██   ░███ ░██        ░██      
				░██     ░██  ░███████  ░██    ░██  ░█████░██  ░███████  ░██                                                                                                                 
	*/


	/* ##########################  Render Function  ########################## */
	/* General rules: The /App allows us to use 100% of the width here. We can also allow each controller to set their own min width, ie: minWidth: "350px" below */
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			{/* Default is gridview, but we may want to wedge closely tied Grid/View items. For example OrdersFlexiGrid along with Orders view for printing. 
				It would be useful to save grid search state and return to it after viewing an order. */}

			{(localstate.configuration.viewmode === "grid") &&
				<div style={{ padding: "8px", overflow: "auto", minWidth: "350px" }}>
					{/* Utility Drawer, good for search options */}
					<Drawer open={showutilitydrawer} style={{ width: "600px" }}>
						<div style={{ height: "47px" }}></div>
						<Typography variant="h4" gutterBottom align="center">
							Utility Drawer
						</Typography>
						<div style={{ width: "400px", padding: "10px" }}>
							<Typography variant="subtitle1" gutterBottom>
								You may want to add some instructional text here.<br></br>
							</Typography>

							{/* You may want access to errors here */}
							{(errors.currenterror.errshow) &&
								<div style={{ textAlign: "center", height: "25px", fontSize: "12px" }}>
									<ErrorMessage />
								</div>
							}
							<NewErrorMessage />

							<Button
								className={classes.bluebtn}
								color="primary" variant="contained"
								onClick={() => CloseUtilityDrawer()}>
								Close
							</Button>

						</div>
					</Drawer>


					{/* Item List - used to load only items placed in text area. */}
					<Drawer open={showitemlist} style={{ width: "600px" }}>
						<div style={{ height: "47px" }}></div>
						<Typography variant="h4" gutterBottom align="center">
							{itemlisttitle}
						</Typography>
						<div style={{ width: "400px", padding: "10px" }}>
							<Typography variant="subtitle1" gutterBottom>
								{itemlistdescription}<br></br>
							</Typography>

							{/* You may want access to errors here */}
							{(errors.currenterror.errshow) &&
								<div style={{ textAlign: "center", height: "25px", fontSize: "12px" }}>
									<ErrorMessage />
								</div>
							}

							<TextareaAutosize style={{ width: "100%" }} minRows={10} placeholder="Paste names from spreadsheet here."
								onChange={(event) => onChangeItemList(event)}
								defaultValue={localstate.searchoptions.itemlist}
							/>

							<Button
								className={classes.bluebtn}
								color="primary" variant="contained"
								onClick={() => CloseItemList()}>
								Close
							</Button>

							{(dupeitems.length > 0) &&
								<div>
									Duplicates found:
									{dupeitems.map(function (dupe, i) {
										//console.log('test');
										return <li key={i}>{dupe}</li>
									})}
								</div>
							}

						</div>
					</Drawer>



					{/* Bulk Edit Drawer */}
					<Drawer open={showbulkeditdrawer} style={{ width: "600px" }}>
						<div style={{ height: "47px" }}></div>
						<Typography variant="h4" gutterBottom align="center">
							Bulk Edit Selected Items
						</Typography>
						<div style={{ width: "400px", padding: "10px" }}>
							{/* Delete Items Confirmation */}
							{(showdeleteconfirmation) &&
								<div>
									<b>Are you sure you want to delete these items?</b>
									<div style={{ padding: "10px 0px" }}>
										Total Items: {deleteitems.length}
									</div>
									<Button className={classes.bluebtn}
										color="primary" variant="contained" onClick={() => DeleteSelected()}>Yes, Delete Items</Button>&nbsp;&nbsp;
									<Button className={classes.bluebtn}
										color="primary" variant="contained" onClick={() => CancelDelete()}>Cancel</Button>
								</div>
							}
							{(!showdeleteconfirmation) &&
								<>
									<Typography variant="subtitle1" gutterBottom>
										Changes apply to all checkbox selected items in the grid view. You may perform multiple changes before returning to the grid. Select change type to get started.<br></br>
									</Typography>
									{/* You may want access to errors here - create parent container to hold position for you. */}
									<div style={{ height: "35px", textAlign: "center" }}>
										{/* {(errors.currenterror.errshow) &&
									<div style={{ textAlign: "center", height: "25px", fontSize: "12px" }}>
										<ErrorMessage />
									</div>
								}
								<NewErrorMessage /> */}
										{validationerror}
									</div>


									<FormControl className={classes.formControl} style={{ width: "300px", paddingTop: "10px" }} variant="standard">
										{/* <InputLabel id="Change type">Change Type: {changetype}</InputLabel> */}
										<Select
											labelId="change-type"
											id="change-type"
											value={changefield}
											onChange={handleChangeEditType}
										>
											{localstate.configuration.bulkeditcolumns.map((column, columnindex) => {
												return (
													<MenuItem key={"bulkedit" + columnindex} value={column.field}
													>
														{column.label}
													</MenuItem>
												)
											})}
										</Select>
									</FormControl>


									{/* Text */}
									{(changetype === "text") &&
										<div>
											<TextField variant="standard" style={{ width: "300px" }} required id="standard-required" defaultValue="" onChange={handleChangeBulkValue} />
										</div>
									}

									{/* Float */}
									{(changetype === "float") &&
										<div>
											<TextField variant="standard" type="number" step="0.01"
												style={{ width: "300px" }}
												required id="standard-required" defaultValue={floatmin}
												onKeyUp={handleChangeBulkValue}
											/>
										</div>
									}

									{/* Integer */}
									{(changetype === "integer") &&
										<div>
											<TextField variant="standard" type="number" step="1"
												style={{ width: "300px" }}
												required id="standard-required" defaultValue={intmin}
												onKeyUp={handleChangeBulkValue}
												slotProps={{
													input: {
														step: 1,
														min: 0,
														onInput: (e) => {
															e.target.value = e.target.value.replace(/\..*$/, ""); // strip decimals
															//This actually works..... no ref. Weird! e.target.value=99999;
														},
													},
												}}
											/>
										</div>
									}


									{/* Select */}
									{(changetype === "select") &&
										<div>
											<FormControl className={classes.formControl} style={{ width: "300px" }} variant="standard">
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													onChange={handleChangeBulkValue}
												>
													{selectoptions.map((option, optionindex) => {
														return (
															<MenuItem key={"bulkeditoption" + optionindex} value={option.value}>{option.label}</MenuItem>
														)
													})}

												</Select>
											</FormControl>
										</div>
									}

									{/* Custom Select */}
									{(changetype === "customselect") &&
										<div>
											<FormControl className={classes.formControl} style={{ width: "300px" }} variant="standard">
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													onChange={handleChangeBulkValue}
												>
													{customselectoptions.map((option, optionindex) => {
														return option;
													})}

												</Select>
											</FormControl>
										</div>
									}



									{/* Autocomplete */}
									{(changetype === "autocomplete") &&
										<div>
											<FlexiGridBulkEditAutoComplete autocompleteconfig={autocompleteconfig} autocompletevalue={autocompletevalue} handleChangeBulkValueAutoComplete={handleChangeBulkValueAutoComplete} />
										</div>
									}


									{/* DateTime */}
									{(changetype === "datetime") &&
										<div className={classes.flexitemdateinputcontainer} style={{ paddingTop: "8px", width: "300px" }}>
											<DateTimePicker
												sx={{ width: "300px" }}
												onChange={handleChangeBulkValue}
												//className={classes.newdatetimepickerinput}
												className={classes.flexitemdateinput}
											/>
										</div>
									}



									<Button
										className={classes.bluebtn}
										color="primary" variant="contained"
										onClick={() => ApplyBulkEdit()}
										ref={el => btnApplyBulkEdit.current = el}>
										Apply Change
									</Button>

									<Button
										className={classes.bluebtn}
										color="primary" variant="contained"
										onClick={() => CloseBulkEditDrawer()}>
										Close
									</Button>
								</>
							}


						</div>
					</Drawer>




					{/* Standard Page Header with right floated error message space */}
					<div style={{ minHeight: "40px", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>
						<h3>{localstate.configuration.title}</h3>
					</div>


					{/* /* ##########################  Search Inputs  ########################################################################################################################################################## */
					/* ######################################################################################################################################################################################################### */}
					{/* Inputs can be Grouped inside of new flex containers: */}

					{/* //convert: {(!isPrintView) && */}




					{/* ORIGINAL */}
					<div style={{ display: "flex", flexGrow: "1", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-evenly" }}>
						{/* Group 1 */}
						<div style={{ display: "flex", flexGrow: "1", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-evenly" }}>
							{configuration.maximuminputs > 0 &&
								<FlexiSearchInput
									searchinput={1}
									key={key1}
									localstate={state}
									configuration={configuration.configuredinputs[0]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>
							}
							{configuration.maximuminputs > 1 &&
								<FlexiSearchInput
									searchinput={2}
									key={key2}
									localstate={state}
									configuration={configuration.configuredinputs[1]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>
							}
							{configuration.maximuminputs > 2 &&
								<FlexiSearchInput
									searchinput={3}
									key={key3}
									localstate={localstate}
									configuration={configuration.configuredinputs[2]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>
							}
							{configuration.maximuminputs > 3 &&
								<FlexiSearchInput
									searchinput={4}
									key={key4}
									localstate={localstate}
									configuration={configuration.configuredinputs[3]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>
							}
						</div>


						{/* Group 2 */}
						{(localstate.configuration.expandsearch) &&
							<div style={{ display: "flex", flexGrow: "1", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-evenly" }}>
								<FlexiSearchInput
									searchinput={5}
									key={key5}
									localstate={localstate}
									configuration={configuration.configuredinputs[4]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>

								<FlexiSearchInput
									searchinput={6}
									key={key6}
									localstate={localstate}
									configuration={configuration.configuredinputs[5]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>
								<FlexiSearchInput
									searchinput={7}
									key={key7}
									localstate={localstate}
									configuration={configuration.configuredinputs[6]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>
								<FlexiSearchInput
									searchinput={8}
									key={key8}
									localstate={localstate}
									configuration={configuration.configuredinputs[7]}
									inputdefaults={configuration.inputdefaults}
									onChangeSearchType={onChangeSearchType}
									onChangeSearchValue={onChangeSearchValue}
									onChangeSearchValueFast={onChangeSearchValueFast}
									UpdateParentState={UpdateParentState}
									onChangeAutoCompleteInput={onChangeAutoCompleteInput}
									selectinputs={localstate.configuration.defaultselectinputs}
								/>
							</div>
						}
					</div>

					{/* End of Search Inputs */}

					{/* ////////// START OF FLEXIGRID ////////// */}

					<div className={classes.flexigridcontainer}>
						{/* Top Buttons & Pagination */}
						{/* Convert: {(!isPrintView) && */}
						<React.Fragment>

							<div style={{ borderBottom: "1px solid #888", fontSize: "12px" }}>
								{/* Buttons - Wrap inside container to prevent them from growing and walking away. */}

								{(!showdeleteconfirmation && !showexportconfirmation) &&
									<React.Fragment>

										{/* If there is in-line Add-Row in your controller,
											you must have create OR update perms set for Save Button.
											Otherwise, just set it for update alone 
											
											
												<Button
													className={(perms.updatePerm || perms.createPerm) ? classes.flexitablebtn : classes.hidden}
													color="blue" variant="contained"
													onClick={() => SaveChanges()}
													ref={el => btnSave.current = el}>
													<SaveIcon sx={{ color: "lightgray" }}></SaveIcon>&nbsp;Save Changes
												</Button>
											
											
											*/}

										{/* BUTTONS CONTAINER */}
										<Grid container sx={{ width: "100%", display: "flex", flexGrow: "1", borderBottom: "2px solid #BBB" }}> {/* set a height for the demo */}


											{/* Use new buttons array! */}

											{(configuration.buttons.map((button, buttonindex) => {
												//console.log(button);
												if (button && button.visible && button.perm && button.visible) {

													{/* Save Button */ }
													if (button.type === "Save" && button.perm) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px", height: "auto" }} ref={el => btnSave.current = el}>
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "28px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		<SaveIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</SaveIcon>&nbsp;Save Changes
																	</Box>
																</Box>
															</Grid>
														)
													}

													{/* Pending Save Button */ }
													if (button.type === "PendingSave" && button.perm && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px", display: "none" }} ref={el => btnPendingSave.current = el}>
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => SaveChanges()}
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		<SaveIcon sx={{
																			color: "green", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</SaveIcon>&nbsp;Save Changes
																	</Box>
																</Box>
															</Grid>
														)
													}

													{/* Add Row Button */ }
													if (button.type === "AddRow" && button.perm && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }} ref={el => btnAddRow.current = el}>
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => AddRow()}
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		<AddIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</AddIcon>&nbsp;Add Row
																	</Box>
																</Box>
															</Grid>
														)
													}

													{/* Add Item Button */ }
													if (button.type === "AddItem" && button.perm && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }} ref={el => btnAddItem.current = el}>
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => AddItem()}
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		<AddIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</AddIcon>&nbsp;{button.text}
																	</Box>
																</Box>
															</Grid>
														)
													}

													{/* View Options Button */ }
													if (button.type === "ViewOptions" && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }}>
																<Box className={showViewOptionsMenu ? classes.flexitablebtnopen : classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => ShowViewOptionsMenu()}
																>
																	<Box className={showViewOptionsMenu ? classes.flexitablebtninneropen : classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																		ref={btnViewOptions}
																	>
																		<GridOnIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</GridOnIcon>&nbsp;{button.text}
																	</Box>
																</Box>
																<Menu
																	sx={{ zIndex: 3000 }} // Adjust the z-index here
																	id="view-options-menu"
																	anchorEl={btnViewOptions.current}
																	keepMounted
																	open={showViewOptionsMenu}
																	onClose={CloseViewOptionsMenu}
																	slotProps={{
																		paper: {
																			elevation: 0, // or keep elevation and drop boxShadow
																			sx: {
																				//ml: -0.5,
																				marginTop: "5px",
																				marginLeft: "-20px",
																				padding: "3px",
																				backgroundColor: "#FFF",
																				borderRadius: "0px",
																				border: "0px",
																				boxShadow: "0px 0px 2px 2px #AAA",
																				fontFamily: "Inter",
																				fontOpticalSizing: "auto",
																				fontWeight: 350,
																			},
																		},
																		// optional: tweak the inner list too
																		list: { sx: { p: 0 } },
																	}}
																>
																	<div style={{ display: "inline-block", overflow: "auto", verticalAlign: "top", }}>
																		<div style={{ textAlign: "center", paddingTop: "10px" }}>Columns</div>
																		<MenuItem disableRipple className={classes.columnmenu}>
																			<div style={{ verticalAlign: "top" }}> {/* Optional container for 2 column menu! */}
																				<div style={{ display: "inline-block", maxHeight: "600px", overflow: "auto", verticalAlign: "top" }}>
																					<FormGroup>
																						{/* ##########################  Column Toggles  ##########################
																						<FlexColumnOption value="Name" label="Name" />
																						<FlexColumnOption value="Cost" label="Cost" />
																						<FlexColumnOption value="Margin" label="Margin" />
																						<FlexColumnOption value="PositiveInteger" label="Positive Int" />
																						<FlexColumnOption value="SomeBoolean" label="Some Boolean" />
																						<FlexColumnOption value="SomeSelectable" label="Some Selectable" />
																						<FlexColumnOption value="NewCheckBox" label="New Checkbox" />
																						<FlexColumnOption value="Date" label="Date" /> */}
																						{localstate.configuration.columns.map((column, columnindex) => {
																							if (column.columnoption) {
																								return (
																									<FlexColumnOption key={"columnoption" + columnindex} column={column} />
																								)
																							}
																						})}
																					</FormGroup>
																				</div>
																			</div>
																		</MenuItem>
																	</div>

																	{(button.config.expandall || button.config.editmode || button.config.expandsearch) &&
																		<div style={{ display: "inline-block", maxHeight: "600px", overflow: "auto", verticalAlign: "top", maxWidth: "200px", padding: "0px 8px" }}>
																			{(localstate.configuration.expandsearch && localstate.configuration.expandall) &&
																				<div style={{ textAlign: "center", paddingTop: "10px" }}>Search Options</div>
																			}																			
																			{(button.config.expandsearch) &&
																				<>
																					<Button
																						className={classes.bluebtn}
																						sx={{ width: "100%" }}
																						color="primary" variant="contained"
																						onClick={() => ToggleExpandSearch()}
																					>
																						{(!localstate.configuration.expandsearch) &&
																							<>Expand Search</>
																						}
																						{(localstate.configuration.expandsearch) &&
																							<>Collapse Search</>
																						}
																					</Button>
																					<br></br><br></br>
																				</>
																			}

																			{(button.config.expandall || button.config.editmode) &&
																				<>
																					<div style={{ textAlign: "center" }}>Table Options</div>
																					{(button.config.expandall) &&
																						<Button
																							className={classes.bluebtn}
																							sx={{ width: "100%" }}
																							color="primary" variant="contained"
																							onClick={() => ExpandAll()}
																							ref={el => btnExpandAll.current = el}
																						>
																							Expand All
																						</Button>
																					}
																					{(button.config.editmode) &&
																						<Button
																							className={(perms.updatePerm) ? classes.bluebtn : classes.hidden}
																							sx={{ width: "100%" }}
																							color="primary" variant="contained"
																							{...(editmode ? {
																								style: {
																									textDecoration: "underline"
																								}
																							} :
																								{
																									style: {
																										textDecoration: "none"
																									},
																									disabled: (localstate.rowsperpage > localstate.configuration.maxrowseditmode ? true : false)
																								})}
																							onClick={() => EditMode()}
																							ref={el => btnEditMode.current = el}
																						>
																							Edit Mode
																						</Button>
																					}
																				</>
																			}
																		</div>
																	}
																</Menu>
															</Grid>
														)
													}


													{/* Edit Items Button */ }
													if (button.type === "EditItems" && button.perm && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }} ref={el => btnEditItems.current = el}>
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => RejectIfInvalidSelected(true, setShowBulkEditDrawer)}
																//onClick={() => setShowBulkEditDrawer(true)}
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		<EditNoteIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</EditNoteIcon>&nbsp;{button.text}
																	</Box>
																</Box>
															</Grid>
														)
													}


													{/* Export Button - Opportunity to add perms here for exportDemoData (which right now doesn't exist)*/ }
													if (button.type === "Export" && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }} ref={el => btnEditItems.current = el}>
																<Box className={showexportmenu ? classes.flexitablebtnopen : classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={ShowExportMenu}
																>
																	<Box className={showexportmenu ? classes.flexitablebtninneropen : classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																		ref={btnShowExportMenu}
																	>
																		<DownloadIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</DownloadIcon>&nbsp;{button.text}
																	</Box>
																</Box>
																<Menu
																	sx={{ zIndex: 3000 }} // Adjust the z-index here
																	id="view-options-menu"
																	anchorEl={btnShowExportMenu.current}
																	keepMounted
																	open={showexportmenu}
																	onClose={CloseExportMenu}
																	slotProps={{
																		paper: {
																			elevation: 0, // or keep elevation and drop boxShadow
																			sx: {
																				//ml: -0.5,
																				marginTop: "5px",
																				//marginLeft: "-20px",
																				padding: "3px",
																				backgroundColor: "#FFF",
																				borderRadius: "0px",
																				border: "0px",
																				boxShadow: "0px 0px 2px 2px #AAA",
																				fontFamily: "Inter",
																				fontOpticalSizing: "auto",
																				fontWeight: 350,
																			},
																		},
																		// optional: tweak the inner list too
																		list: { sx: { p: 0 } },
																	}}
																>

																	<div style={{ textAlign: "center", padding: "8px" }}>Export Options</div>

																	<MenuItem onClick={() => RejectIfInvalidSelected("selected", InitExport)}>Export Selected</MenuItem>
																	<MenuItem onClick={() => InitExport("searchresults")}>Export Search Results <br></br> (limit {localstate.configuration.exportoptions.limit})</MenuItem>
																</Menu>
															</Grid>
														)
													}


													{/* Item List Button */ }
													if (button.type === "ItemList" && button.perm && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }} ref={el => btnAddRow.current = el}>
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => SetItemList(button)}
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		<ReceiptLongIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</ReceiptLongIcon>&nbsp;{button.text}
																	</Box>
																</Box>
															</Grid>
														)
													}

											
													{/* Custom Buttons! */ }
													if (button.type.includes("CustomButton") && button.perm && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }} ref={el => btnAddRow.current = el}>
																{(button.fileinput) &&
																	<input
																	type="file"
																	ref={fileInputRef}
																	onChange={(event) => button.handleFileChange({ 
																		event, 
																		incrementPass, 
																		incrementFail, 
																		setErrorTimeout, 
																		localstate, 
																		UpdateState, 
																		dispatch, 
																		newStatus, 
																		setStatusTimeout 
																	  })}
																	  accept=".json,.html"
																	style={{ display: 'none' }}
																  />
																}
																
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => 
																		button.requiresselection
																		  ? RejectIfInvalidSelected(null, () => 
																			  button.customfunction({ localstate, UpdateState, dispatch, newStatus, setStatusTimeout })
																			)
																		  : //Another Ternary
																		  button.fileinput ? fileInputRef.current.click() : button.customfunction({ localstate, UpdateState, dispatch, newStatus, setStatusTimeout })
																	  }
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		{button.icon}
																		&nbsp;{button.text}
																	</Box>
																</Box>
															</Grid>
														)
													}


													{/* Reset Search Button */ }
													if (button.type === "Reset" && button.perm && button.visible) {
														return (
															<Grid key={"tablebtns" + buttonindex} sx={{ flexGrow: "1", display: "flex", maxWidth: "175px" }} ref={el => btnAddRow.current = el}>
																<Box className={classes.flexitablebtn}
																	sx={{
																		flexGrow: "1", textAlign: "center", height: {
																			xs: "26px",
																			sm: "30px",
																			md: "35px",
																			lg: "35px"
																		}
																	}}
																	onClick={() => ResetSearches()}
																>
																	<Box className={classes.flexitablebtninner}
																		sx={tablebuttonstyle}
																	>
																		<RestartAltIcon sx={{
																			color: "#222", fontSize: "1.2em", // match text size
																			verticalAlign: "middle", // helps on some browsers
																			display: "inline-block",
																		}}>
																		</RestartAltIcon>&nbsp;{button.text}
																	</Box>
																</Box>
															</Grid>
														)
													}



													// 		<Button
													// 	className={classes.bluebtn}
													// 	color="primary" variant="contained"
													// 	aria-haspopup="true"
													// 	onClick={ShowExportMenu}
													// 	ref={el => btnExport.current = el}>
													// 	Export
													// </Button>

													// <Menu id="export-menu"
													// 	anchorEl={showexportmenu}
													// 	keepMounted
													// 	open={Boolean(showexportmenu)}
													// 	onClose={CloseExportMenu}>
													// 	<MenuItem onClick={() => RejectIfInvalidSelected("selected", InitExport)}>Export Selected</MenuItem>
													// 	<MenuItem onClick={() => InitExport("searchresults")}>Export All (limit 2000)</MenuItem>
													// </Menu>


												}
											}))}
											{/* End of buttons map */}




											{/* Spacer */}
											<Grid key={"tablebtnspacer"} sx={{
												width: {
													sm: "4px",
													md: "4px",
													lg: "30px"
												}
											}}>
												&nbsp;
											</Grid>


											<Grid sx={{ flexGrow: "1", ml: "auto", }}>
												<Grid container sx={{
													width: {
														xs: "100%",
														md: "100%"
													},
													display: "flex", flexGrow: "1", justifyContent: "flex-end"
												}}>

													{configuration.statusbar &&
														<Grid
															sx={{
																width: {
																	xs: "100%",
																	sm: "170px",
																	md: "200px",
																	lg: "250px",
																	xl: "250px"
																},
																display: "flex",
																height: "30px",
																ml: "auto",             // <--- pushes this item to the right
																//alignItems: "flex-end",   // Optional: adjust horizontal alignment
																verticalAlign: "bottom",
																flexGrow: "1",
																textAlign: "right",
																// alignContent:"end",
																// alignItems:"end" 
															}}
														>
															<Box sx={{
																ml: "auto",
																width: {
																	xs: "100%",
																	sm: "100%",
																	md: "100%",
																	lg: "100%",
																	xl: "250px"
																},
															}}>
																{/* I was this Box to go all the way to the end of the grown Grid item */}
																<Box sx={{
																	height: {
																		xs: "26px",
																		sm: "30px",
																		md: "30px",
																		lg: "30px"
																	},
																	minWidth: "170px",
																	backgroundColor: "#CCC",
																	marginTop: "5px",
																	marginRight: "4px",
																	marginLeft: "4px",
																	verticalAlign: "middle",
																}}>
																	<StatusBar />
																</Box>
															</Box>

														</Grid>
													}



													<Grid sx={{ flexGrow: "0", textAlign: "right" }}>

														{(localstate.totalitems > 0) &&
															<FlexiGridPagination
																localstate={localstate}
																classes={classes}
																editmode={editmode}
																handleChangePage={handleChangePage}
																handleChangeRowsPerPage={handleChangeRowsPerPage}
															/>
														}
													</Grid>
												</Grid>
											</Grid>




										</Grid>































										{(false && configuration.buttons.Save.visible && perms.updatePerm) &&
											<Box className={classes.flexitablebtn}
												style={{ display: "none" }}
												onClick={() => SaveChanges()}
												ref={el => btnPendingSave.current = el}>
												<Box className={classes.flexitablebtninner}>
													<SaveIcon sx={{
														color: "green", fontSize: "1.2em", // match text size
														verticalAlign: "middle", // helps on some browsers
														display: "inline-block",
													}}>
													</SaveIcon>&nbsp;Save Changes
												</Box>
											</Box>
										}



										{/* <Button
												className={(configuration.buttons.PendingSave.visible && (perms.updatePerm || perms.createPerm)) ? classes.bluebtn : classes.hidden}
												color="primary" variant="contained"
												style={{ display: "none" }}
												onClick={() => SaveChanges()}
												ref={el => btnPendingSave.current = el}>
												<PendingIcon sx={{ color: "orange" }}></PendingIcon>&nbsp;Save Changes
											</Button> */}

										{(false && configuration.buttons.AddRow.visible && perms.createPerm) &&
											<Box className={classes.flexitablebtn}
												onClick={() => AddRow()}
												ref={el => btnAddRow.current = el}>
												<Box className={classes.flexitablebtninner}>
													<AddIcon sx={{
														color: "#222", fontSize: "1.2em", // match text size
														verticalAlign: "middle", // helps on some browsers
														display: "inline-block",
													}}>
													</AddIcon>&nbsp;Add Row
												</Box>
											</Box>
										}


										{/* <Button
												className={(configuration.buttons.AddRow.visible && perms.createPerm) ? classes.bluebtn : classes.hidden}
												color="primary" variant="contained"
												onClick={() => AddRow()}
												ref={el => btnAddRow.current = el}>
												<AddIcon />&nbsp;Add Row
											</Button> */}


										{(false && configuration.buttons.AddRow.visible && perms.createPerm) &&
											<Box className={classes.flexitablebtn}
												onClick={() => AddItem()}
												ref={el => btnAddItem.current = el}>
												<Box className={classes.flexitablebtninner}>
													<AddIcon sx={{
														color: "#222", fontSize: "1.2em", // match text size
														verticalAlign: "middle", // helps on some browsers
														display: "inline-block",
													}}>
													</AddIcon>&nbsp;Add Item
												</Box>
											</Box>
										}




										{/* <Button
												className={(configuration.buttons.AddItem.visible && perms.createPerm) ? classes.bluebtn : classes.hidden}
												color="primary" variant="contained"
												onClick={() => AddItem()}
												ref={el => btnAddItem.current = el}>
												<AddIcon />&nbsp;Add Item
											</Button> */}


										{/* New View Options Menu */}
										{/* Compact a lot of table view options into this one menu to save space! */}


										{/* END OF VIEW OPTIONS MENU */}




										{/* NEW EDIT MENU */}
										{/* Compact a lot of table view options into this one menu to save space! */}
										{/* <Button
												className={classes.bluebtn}
												color="primary" variant="contained"
												aria-haspopup="true"
												onClick={ShowViewEditMenu}>
												Edit Items
											</Button>

											<Menu
												className={classes.bluebtn}
												color="primary"
												id="edit-menu"
												anchorEl={showViewEditMenu}
												keepMounted
												open={Boolean(showViewEditMenu)}
												onClose={CloseViewEditMenu}
											>
												<MenuItem
													onClick={() => RejectIfInvalidSelected(true, setShowBulkEditDrawer)}
													ref={el => btnEditSelected.current = el}
												>
													Bulk Edit Selected Items
												</MenuItem>
												<MenuItem
													onClick={() => RejectIfInvalidSelected("", DeleteSelectedInit)}
													ref={el => btnDeleteSelected.current = el}
													sx={{
														'&:hover': {
															backgroundColor: 'lightred', // Background color on hover
														},

													}}
												>
													Delete Selected Items
												</MenuItem>
											</Menu> */}
										{/* END OF EDIT MENU */}



										{/* <Button
												className={classes.bluebtn}
												color="primary" variant="contained"
												aria-haspopup="true"
												onClick={ShowExportMenu}
												ref={el => btnExport.current = el}>
												Export
											</Button>

											<Menu id="export-menu"
												anchorEl={showexportmenu}
												keepMounted
												open={Boolean(showexportmenu)}
												onClose={CloseExportMenu}>
												<MenuItem onClick={() => RejectIfInvalidSelected("selected", InitExport)}>Export Selected</MenuItem>
												<MenuItem onClick={() => InitExport("searchresults")}>Export All (limit 2000)</MenuItem>
											</Menu>

											<Button
												className={classes.bluebtn}
												color="primary" variant="contained"
												onClick={() => setShowUtilityDrawer(true)}
												ref={el => btnUtilityDrawer.current = el}>
												Utility Drawer
											</Button>

											<Button
												className={classes.bluebtn}
												color="primary" variant="contained"
												onClick={() => setShowItemList(true)}
												{...(localstate.searchoptions.itemlist !== '' ? {
													style: {
														textDecoration: "underline"
													}
												} :
													{
														style: {
															textDecoration: "none"
														}
													})}
												ref={el => btnItemList.current = el}>
												Item List
											</Button>

											<Button
												className={classes.bluebtn}
												color="primary" variant="contained"
												onClick={() => PrintLabels()}
												ref={el => btnPrintLabels.current = el}>
												Print Labels
											</Button>
											<Button
												className={classes.bluebtn}
												color="primary" variant="contained"
												onClick={() => ResetSearches()}
												ref={el => btnResetSearches.current = el}>
												<RestartAltIcon />&nbsp;Reset
											</Button> */}
									</React.Fragment>
								}


								{/* Export Type Confirmation */}
								{(showexportconfirmation) &&
									<div style={{ padding: "5px" }}>
										<b>Export Type</b><br></br>
										{localstate.configuration.exportoptions.exportmessage}
										<div style={{ paddingTop: "10px" }}>
											{localstate.configuration.exportoptions.exporttypes.map((exportcfg, exportcfgindex) => {
												return (
													<Button
														key={"exporttypebtn" + exportcfgindex}
														className={classes.bluebtn}
														color="primary" variant="contained"
														onClick={() => PrepareExport(exportcfg)}>
														{exportcfg.type}
													</Button>
												);
											}
											)}
										</div>
									</div>
								}


							</div>
						</React.Fragment>

						{/* End of Top Buttons & Pagination */}




						{/* ##########################  FLEXIGRID TABLE RENDER  ########################## */}
						{/* Smash new render into here! Borrow what you need */}
						{/* Attempt to render this within a div that grows with the content. That way our border applies to the top of the table instead of the bottom of the uppder buttons and pagination */}
						{/* 1/28/2026 Attempt to remove overflowX:auto from the div below */}
						<div style={{ borderTop: "1px solid #AAA", width: "100%" }}>
							<table id="resizeMe" aria-label="caption table" size="small" className={classes.flexigrid} style={{
								minWidth: "100%", borderCollapse: "collapse",
								border: localstate.configuration.tablebordertype === "open" ? "0px" : localstate.configuration.tablebordertype === "thin" ? "1px solid grey" : "2px solid #D4D4D4"
							}}>
								{/* ##########################  HEADERS  ########################## */}
								{(localstate.configuration.showcolumnheaders && localstate.griditems.length > 0) &&
									<thead style={{ display: "table-header-group" }}>
										<tr style={{ border: "1px solid #CCC", backgroundColor: "blue" }}>
											{localstate.configuration.columns.map((column, columnindex) => {
												if (column.visible) {
													if (column.columnheader === "maincheckbox") {
														return (
															<td key={"cindex" + columnindex}
																className={classes.flexigridcustomcontainer}
																style={{ width: "28px" }}
															>
																<div style={{ padding: "0px 4px 2px 5px" }}>
																	<Checkbox
																		className={classes.gridcheckbox}
																		disableRipple
																		color="default"
																		checked={localstate.griditems.length === localstate.selectedindexes.length}
																		checkedIcon={<span className={classes.icon + " " + classes.checkedIcon} />}
																		icon={<span className={classes.icon} />}
																		onChange={handleSelectAllClick}
																	/>
																</div>
															</td>
														);
													}
													if (column.columnheader === "text") {
														return (
															<td
																key={"cindex" + columnindex}
																align={column.columnheaderalign}
																style={column.columnheaderstyle}
															>
																<div style={{ padding: "0px 3px 0px 3px", fontSize: "12px" }}>
																	{(column.allowsort) &&
																		<TableSortLabel
																			active={localstate.orderby === column.field}
																			direction={localstate.order}
																			onClick={() => sortByColumn(column)}
																			hideSortIcon={(localstate.orderby === column.field ? false : true)}

																		>
																			{/* If current sort, show bold label */}
																			{(localstate.orderby === column.field)
																				? <span style={{ fontWeight: "bold" }}>{column.columnheadertext}</span>
																				: <span>{column.columnheadertext}</span>
																			}
																		</TableSortLabel>
																	}
																	{(!column.allowsort) &&
																		// <TableSortLabel active={false} hideSortIcon={true}>
																		// <span>{column.columnheadertext}</span>
																		// </TableSortLabel>
																		<span>{column.columnheadertext}</span>
																	}
																</div>

															</td>
														)
													}
												}
											})}
										</tr>
									</thead>
								}

								{/*     Table Body     */}
								{(!localstate.dbreload) &&
									<tbody style={{ display: "table-row-group" }}>
										{(localstate.griditems.length > 0) &&
											localstate.griditems.map((row, index) => {
												return (
													<React.Fragment key={"gridrow" + index}>
														<tr className={classes.flexgridrow}>
															<FlexiRow
																index={index}
																row={row}
																rowRefs={rowRefs}
																localstate={localstate}
																UpdateState={UpdateState}
																classes={classes}
																configuration={localstate.configuration}
																defaultChecked={localstate.griditems[index].isSelected ? true : false} //Used for checkbox
																checked={localstate.griditems[index].isSelected ? true : false}
																HandleKeyDown={HandleKeyDown}
																onChangeValue={onChangeValue}
																onChangeAutoCompleteValue={onChangeAutoCompleteValue}
																SelectRow={SelectRow}
																ExpandRowToggle={ExpandRowToggle}
																editmode={editmode}
																ResetKeys={ResetKeys} //Adds ability to update search inputs
															/>
														</tr>
														{(row.ExpandRow) &&
															<tr key={"gridrow" + index + "expandedrow"}>
																{/* <td>
																	This
																</td> */}
																{localstate.configuration.expandedrowrender({ localstate, index, classes, UpdateState })}
															</tr>
														}
													</React.Fragment>
												)
											}
											)
										}
										{(localstate.griditems.length === 0) &&
											<tr className="flexgridrow"><td colSpan="100%"
												style={{ padding: "12px", fontSize: "18px", backgroundColor: "#EEE" }}>No results for found for this search.
												{(itemlistsearch.length > 0) &&
													<b>&nbsp;Item list is active.</b>
												}
											</td></tr>
										}
									</tbody>
								}
								{(localstate.dbreload) &&
									<tbody>
										<tr>
											<td colSpan="100%">
												<div style={{ padding: "20px", textAlign: "center", margin: "auto" }}>
													<CircularProgress />
												</div>
											</td>
										</tr>
									</tbody>
								}
							</table>
						</div>

					</div>


					{/* ////////// END OF FLEXIGRID ////////// */}







					{/* OPTIONAL RENDER OF OLD TABLE. AVOID REF ISSUES? */}

					{/* Add container for overflow scroll bars - Allows us to set a min width for the page (better looking in many cases), and freeze controls at the top and bottom for ease of use. */}
					{(false) &&
						<div className={classes.flexgridcontainerA}>
							{/* ##########################  Start of Table  ########################## */}
							<table id="resizeMe" aria-label="caption table" size="small" className={classes.flexgrid} style={{ minWidth: "100%", borderCollapse: "collapse", borderColor: "grey" }}>

								{/* /* ##########################  Row Design  ########################## */}
								{/* If DB reload, don't allow view of table. */}
								{(!localstate.dbreload) &&
									<tbody style={{ display: "table-row-group" }}>
										{(localstate.griditems.length > 0) &&
											localstate.griditems.map((row, index) => {
												//Create all-new refs on each render. Helps avoid issues with grid states.
												rowRefs.current[index + "Checkbox"] = React.createRef();
												rowRefs.current[index + "SaveStatus"] = React.createRef();
												rowRefs.current[index + "Name"] = React.createRef();
												rowRefs.current[index + "Cost"] = React.createRef();
												rowRefs.current[index + "Price"] = React.createRef();
												rowRefs.current[index + "Margin"] = React.createRef();
												rowRefs.current[index + "PositiveInteger"] = React.createRef();
												rowRefs.current[index + "SomeBoolean"] = React.createRef();
												return (
													<React.Fragment key={row.ID}>
														<tr className={classes.flexgridrow}>
															{/* Checkbox - Requires inner div to change background color with SaveStatus */}
															<td style={{ verticalAlign: "top" }} ref={el => rowRefs.current[index + "SaveStatus"] = el}>
																<div style={{ padding: "3px 4px 1px 4px" }}>
																	{/*	MaterialUI Checkbox will pass a shallow comparison between UpdateState(s). Be sure GridKey changes if it needs to be rerendered such as selectall.	*/}
																	<Checkbox
																		key={row.GridKey}
																		inputRef={el => rowRefs.current[index + "Checkbox"] = el}
																		className={classes.gridcheckbox}
																		color="default"
																		defaultChecked={localstate.griditems[index].isSelected ? true : false}
																		checkedIcon={<span className={classes.icon + " " + classes.checkedIcon} />}
																		icon={<span className={classes.icon} />}
																		onKeyDown={(event) => HandleKeyDown(event, index, "Checkbox")}
																		onChange={() => SelectRow(index)}
																	/>
																</div>
															</td>

															{/* UserPerms Note: If the user can't use the EditMode button nor API calls to edit items, we can simply count on editmode not being accessible while ignoring the given updateX userPerm */}

															{/* Name - Allow users with createDemoData perm to edit this row if it's pending! */}
															{((editmode && colstate.Name) || (colstate.Name && row.PendingItem === 1 && perms.createPerm)) &&
																<td className={classes.flexgridinputcontainer}>
																	<input
																		ref={el => rowRefs.current[index + 'Name'] = el}
																		className={classes.flexgridinput30}
																		style={{ minWidth: '50px', textAlign: "left" }}
																		onKeyDown={(event) => HandleKeyDown(event, index, 'Name')}
																		onKeyUp={(event) => onChangeValue(event, index, 'Name')}
																		defaultValue={localstate.defaultvalues[index].Name} />
																</td>
															}

															{(!editmode && colstate.Name && row.PendingItem === 0) &&
																<td className={classes.flexgridstaticcontainer}>
																	{/* <PreviewIcon className={classes.transparenticon} color="primary" fontSize="inherit" onClick={()=>{GoToItem(row.ID)}}></PreviewIcon> */}
																	<a href={hostbase + "/boilerplatekeyvalues/" + row.ID} target="_blank">{row.Name}</a>
																	{/* {localstate.configuration.columns.Name.visible &&
																	localstate.configuration.columns.Name.render === "custom" &&
																	typeof localstate.configuration.columns.Name.customelement === "function" &&
																	localstate.configuration.columns.Name.customelement({ item: row })
																} */}
																	{localstate.configuration.columns.find(col => col.field === "Cost")?.value}

																</td>
															}



															{/* Alernate EXPAND ROW version: 
														{(colstate.Name) &&
															<React.Fragment>
																{(editmode && colstate.Name) &&
																	<td className={classes.flexgridinputcontainer}>
																		{(!row.ExpandRow) &&
																			<div className={classes.flexgridexpand}>
																				<ExpandMoreIcon className={classes.transparenticon} color="primary" fontSize="inherit" onClick={() => ExpandRowToggle(index)}></ExpandMoreIcon>
																			</div>
																		}
																		{(row.ExpandRow) &&
																			<div className={classes.flexgridexpand}>
																				<ExpandLessIcon className={classes.transparenticon} color="primary" fontSize="inherit" onClick={() => ExpandRowToggle(index)}></ExpandLessIcon>
																			</div>
																		}
																		<input
																			ref={el => rowRefs.current[index + 'Name'] = el}
																			className={classes.flexgridinput30}
																			style={{ minWidth: '50px', textAlign: "left" }}
																			onKeyDown={(event) => HandleKeyDown(event, index, 'Name')}
																			onKeyUp={(event) => onChangeValue(event, index, 'Name')}
																			defaultValue={localstate.defaultvalues[index].Name} />
																	</td>
																}

																{(!editmode && colstate.Name) &&
																	<td className={classes.flexgridstaticcontainer}>
																		{(!row.ExpandRow) &&
																			<div className={classes.flexgridexpand}>
																				<ExpandMoreIcon className={classes.transparenticon} color="primary" fontSize="inherit" onClick={() => ExpandRowToggle(index)}></ExpandMoreIcon>
																			</div>
																		}
																		{(row.ExpandRow) &&
																			<div className={classes.flexgridexpand}>
																				<ExpandLessIcon className={classes.transparenticon} color="primary" fontSize="inherit" onClick={() => ExpandRowToggle(index)}></ExpandLessIcon>
																			</div>
																		}
																		<div className={classes.flexgridexpand}>
																			<PreviewIcon className={classes.transparenticon} color="primary" fontSize="inherit" onClick={()=>{GoToItem(row.ID)}}></PreviewIcon>
																		</div>
																		{row.Name}
																	</td>
																}
															</React.Fragment>
														}          /*}


														{/* Cost - Can also be used for Integers! Change onChangeValue method to use RestrictNumberInteger */}
															{((editmode && colstate.Cost) || (colstate.Cost && row.PendingItem === 1 && perms.createPerm)) &&
																<td className={classes.flexgridinputcontainer}>
																	<input
																		type="number" step="0.01"
																		ref={el => rowRefs.current[index + 'Cost'] = el}
																		className={classes.flexgridinput}
																		style={{ minWidth: '50px', textAlign: "right" }}
																		onKeyDown={(event) => HandleKeyDown(event, index, 'Cost')}
																		onKeyUp={(event) => onChangeValue(event, index, 'Cost')}
																		onBlur={(event) => DetectBlankNumber(event, index, "Cost")}
																		defaultValue={localstate.defaultvalues[index].Cost} />
																</td>
															}

															{(!editmode && colstate.Cost && row.PendingItem === 0) &&
																<td className={classes.flexgridstaticcontainer}>
																	{row.Cost}
																</td>
															}


															{/* Price */}
															{((editmode && colstate.Price) || (colstate.Price && row.PendingItem === 1 && perms.createPerm)) &&
																<td className={classes.flexgridinputcontainer}>
																	<input
																		type="number" step="0.01"
																		ref={el => rowRefs.current[index + 'Price'] = el}
																		className={classes.flexgridinput}
																		style={{ minWidth: '50px', textAlign: "right" }}
																		onKeyDown={(event) => HandleKeyDown(event, index, 'Price')}
																		onKeyUp={(event) => onChangeValue(event, index, 'Price')}
																		onBlur={(event) => DetectBlankNumber(event, index, "Price")}
																		defaultValue={localstate.defaultvalues[index].Price} />
																</td>
															}

															{(!editmode && colstate.Price && row.PendingItem === 0) &&
																<td className={classes.flexgridstaticcontainer}>
																	{row.Price}
																</td>
															}

															{/* Margin */}
															{(colstate.Margin) &&
																<td className={classes.flexgridstaticcontainer}>
																	<span ref={el => rowRefs.current[index + "Margin"] = el}>
																		{row.Margin}
																	</span>
																</td>
															}

															{/* PositiveInteger */}
															{((editmode && colstate.PositiveInteger) || (colstate.PositiveInteger && row.PendingItem === 1 && perms.createPerm)) &&
																<td className={classes.flexgridinputcontainer}>
																	<input
																		type="number" step="1"
																		ref={el => rowRefs.current[index + 'PositiveInteger'] = el}
																		className={classes.flexgridinput}
																		style={{ minWidth: '50px', textAlign: "right" }}
																		onKeyDown={(event) => HandleKeyDown(event, index, 'PositiveInteger')}
																		onKeyUp={(event) => onChangeValue(event, index, 'PositiveInteger')}
																		onBlur={(event) => DetectBlankNumber(event, index, "PositiveInteger")}
																		defaultValue={localstate.defaultvalues[index].PositiveInteger} />
																</td>
															}
															{(!editmode && colstate.PositiveInteger && row.PendingItem === 0) &&
																<td className={classes.flexgridstaticcontainer}>
																	{row.PositiveInteger}
																</td>
															}

															{/* SomeBoolean */}
															{(colstate.SomeBoolean) &&
																<td>
																	{/* Try not to use this version of a boolean checkbox. It incurs expensive rerenders.*/}
																	<div style={{ padding: "3px 4px 1px 4px" }}>
																		<input type="checkbox"
																			ref={el => rowRefs.current[index + "SomeBoolean"] = el}
																			checked={row.SomeBoolean === 1}
																			onChange={(event) => onChangeValue(event, index, "SomeBoolean")}
																		/>
																		{row.SomeBoolean}
																	</div>
																</td>
															}

															{/* SomeSelectable */}
															{((editmode && colstate.SomeSelectable) || (colstate.SomeSelectable && row.PendingItem === 1 && perms.createPerm)) &&
																<td>
																	<FormControl className={classes.formControl} variant="standard">
																		{/* <InputLabel id="demo-controlled-open-select-label">Optional Label</InputLabel> */}
																		{/* Need: Set default value if row.SomeSelectable is null. */}
																		{/* Why: Some of the values may be momentarily null for some reason - DB fetch, rerender? */}

																		{/* Override icon prop class to our custom 'nodisplay' to remove arrowdown icon for this select */}
																		{/* Override select prop class with new padding specs */}

																		<Select
																			defaultValue={row.SomeSelectableDefault ? row.SomeSelectableDefault : "--"} disableUnderline
																			onChange={(event) => onChangeValue(event, index, "SomeSelectable")}
																			classes={{
																				icon: classes.nodisplay,
																				select: classes.selectpadding
																			}}
																		>
																			<MenuItem value="--">
																				<em>None</em>
																			</MenuItem>
																			<MenuItem value={10}>Ten</MenuItem>
																			<MenuItem value={"A"}>
																				<Chip size="small" label="A" clickable className={classes.gradea} />
																			</MenuItem>
																			<MenuItem value={"B"}>
																				<Chip size="small" label="B" clickable className={classes.gradeb} />
																			</MenuItem>
																			<MenuItem value={"C"}>
																				<Chip size="small" label="C" clickable className={classes.gradec} />
																			</MenuItem>
																			<MenuItem value={"Bad"}>
																				<Chip size="small" label="Bad" clickable className={classes.gradebad} />
																			</MenuItem>
																			<MenuItem value={"Repair"}>
																				<Chip size="small" label="Repair" clickable className={classes.graderepair} />
																			</MenuItem>
																			<MenuItem value={"Scrap"}>
																				<Chip size="small" label="Scrap" clickable className={classes.gradescrap} />
																			</MenuItem>
																		</Select>
																	</FormControl>
																</td>
															}
															{(!editmode && colstate.SomeSelectable && row.PendingItem === 0) &&
																<td className={classes.flexgridstaticcontainer}>
																	{row.SomeSelectable}
																</td>
															}




															{/* NewCheckbox */}
															{((editmode && colstate.NewCheckbox) || (colstate.NewCheckbox && row.PendingItem === 1 && perms.createPerm)) &&
																<td>
																	<div style={{ padding: "4px 4px 1px 4px", textAlign: "center" }}>
																		<Checkbox
																			className={classes.gridcheckbox}
																			disableRipple
																			color="default"
																			defaultChecked={row.NewCheckbox === 1 ? true : false}
																			checkedIcon={<span className={classes.icon + " " + classes.checkedIcon} />}
																			icon={<span className={classes.icon} />}
																			onChange={(event) => onChangeValue(event, index, "NewCheckbox")}
																		/>
																	</div>
																</td>
															}
															{(!editmode && colstate.NewCheckbox && row.PendingItem === 0) &&
																<td className={classes.flexgridstaticcontainer}>
																	<Checkbox
																		className={classes.gridcheckbox}
																		disabled //!!!!!
																		disableRipple
																		color="default"
																		defaultChecked={row.NewCheckbox === 1 ? true : false}
																		checkedIcon={<span className={classes.icon + " " + classes.checkedIcon} />}
																		icon={<span className={classes.icon} />}
																		onChange={(event) => onChangeValue(event, index, "NewCheckbox")}
																	/>
																</td>
															}



															{/* Date */}
															{(colstate.Date) &&
																<td className={classes.flexgridstaticcontainer}>
																	UTC: {row.Date}<br></br>
																	DayJS: {dayjs(row.Date).format("MMMM D, YYYY [at] h:mma")}
																	{/* No tz given: <Moment element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br>
																Localized: <Moment tz="America/New_York" element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br>
																Bermuda: <Moment tz="Atlantic/Bermuda" element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br>
																Los Angeles: <Moment tz="America/Los_Angeles" element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br> */}
																</td>
															}

														</tr>
														{/* Try: conditional for any render whatsoever! */}
														{(row.ExpandRow === true) &&
															<tr>
																<td colSpan="100%">
																	<div style={{ margin: "25px" }}>
																		Expanded column container!
																	</div>
																</td>
															</tr>
														}
													</React.Fragment>

												)
											}
											)
										}
										{(localstate.griditems.length === 0) &&
											<tr className="flexgridrow"><td colSpan="100%"
												style={{ padding: "12px", fontSize: "18px" }}>No Results</td></tr>
										}
									</tbody>
								}
								{(localstate.dbreload) &&
									<tbody>
										<tr>
											<td colSpan="100%">
												<div style={{ padding: "20px", textAlign: "center", margin: "auto" }}>
													<CircularProgress />
												</div>
											</td>
										</tr>
									</tbody>
								}
							</table>
						</div>
					}



					{(localstate.totalitems > localstate.rowsperpage) &&
						<FlexiGridPagination
							localstate={localstate}
							classes={classes}
							editmode={editmode}
							handleChangePage={handleChangePage}
							handleChangeRowsPerPage={handleChangeRowsPerPage}
						/>
					}
				</div>
			}

			{(localstate.configuration.childcontroller && localstate.configuration.viewmode!=="grid") &&
				<>
					<localstate.configuration.childcontroller
						isChild={true}
						currentids={localstate.currentids} 
						viewmode={localstate.configuration.viewmode} 
						SetView={SetView} 
						draft={false}
						UpdateState={UpdateState}
					/>
				</>

			}
			
		</LocalizationProvider>
	);
}

export default FlexiGrid;